import cn from 'classnames'
import { GetSignatureId } from 'legacy/lut/classes/helpers/partner360/CommitmentHelper'
import { usePartnerId } from 'legacy/lut/classes/helpers/partner360/usePartnerId'
import { usePartnerInfo } from 'legacy/lut/classes/helpers/partner360/usePartnerInfo'
import ValidationHelper from 'legacy/lut/classes/helpers/partner360/ValidationHelper'
import { IFormActualsTargetsSettings } from 'legacy/lut/classes/models/partner360/IFormActualsTargetsSettings'
import { IFormPartnerBasicInfo } from 'legacy/lut/classes/models/partner360/IFormPartnerBasicInfo'
import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { requestGlobalPartnerData } from 'legacy/lut/features/globalPartner'
import { requestRecalculateCompleteness } from 'legacy/lut/features/partner360/completeness'
import { selectPartnerAccess } from 'legacy/lut/features/partner360/configuration'
import { useJbpSettings } from 'legacy/lut/features/partner360/jbpSettings'
import {
  selectSectionSettings,
  updateSectionSettings,
} from 'legacy/lut/features/partner360/sectionSettings'
import { Fragment, useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import { NumberInput } from 'cng-common/components/numberInput'
import { Translation } from 'cng-common/features/translations/components/translation'
import { useSafetyTranslation } from 'cng-common/features/translations/hooks'
import { Button } from 'core-components/library/button'
import { Checkbox } from 'core-components/library/checkbox'
import { Loader } from 'core-components/library/loader'
import { ModalDialog } from 'core-components/library/modalDialog'
import { NotificationController, TPopupHorizontal } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'
import { Controller, ValidationStatus } from 'core-components/library/validation'
import { URLContext } from 'core/routes/urlController'
import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'
import Logger from 'core/utils/Logger'
import { ActualsTypeButtons, useActualsTypes } from 'partner360/components/actualsTypeButtons'
import { CurrenciesButtons, useCurrencies } from 'partner360/components/currenciesButtons'
import { RowButtons } from 'partner360/components/rowButtons/RowButtons'
import { SellTypeButtons } from 'partner360/components/sellTypeButtons/SellTypeButtons'
import { AdditionalInfoKeys } from 'partner360/entities/planning'
import { isSubCategoryMandatory } from 'partner360/entities/planning'
import {
  changeFinSobIsCategoryPlanningApplyingChangesLoading,
  changeFinSobIsCategoryPlanningDataLoading,
} from 'partner360/features/finSob/finSobSlice'
import { requestCompletenessStatusForFinSobSidePanelItem } from 'partner360/features/finSobSidePanel/api/requestCompletenessStatusForFinSobSidePanelItem'
import { isSectionSettingOn } from 'partner360/helpers/sectionSettings/isSectionSettingOn'
import { useChangeNotApplicable } from 'partner360/hooks/finSob/useChangeNotApplicable'
import { scrollElementIntoPage } from 'partner360/lib/planSectionDialog'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { createSectionSettingsPatch } from '../../../../../../../features/partner360/sectionSettings/models/iSectionSettingsState'
import { useAppDispatch } from '../../../../../../../hooks/useAppDispatch'
import { useUserRoles } from '../../../../../../../hooks/useUserRoles'
import { CommitmentChangeDialog } from '../../../commitment/CommitmentChangeDialog'
import { GrowField } from '../../../components/GrowField'
import { useTargetsUrlDeps } from '../../../editors/useTargetsUrlDeps'
import { HelpSection } from '../../../helpButton'
import { IJBPPlanning, IJBPPlanningItem } from '../../../models/IJBPPlanning'
import { NotApplicableWidget } from '../../../notApplicableWidget/NotApplicable'
import { TypeChangeDialog } from '../../../programsManagementAdmin/TypeChangeDialog'
import { applyJBPPlanning } from '../../../services/applyJBPPlanning'
import { cleanPlanningItemForApi } from '../../../services/cleanPlanningItemForApi'
import { WidgetHeaderWithHelpButton } from '../../../widgetHeader'
import { WidgetHeader } from '../../../widgetHeader/WidgetHeader'
import { CategoryInfo } from '../../components/categoryInfo/CategoryInfo'
import { MandatoryField } from '../../components/mandatoryField/MandatoryField'
import { MapRow } from '../../components/mapRow/MapRow'
import { PartnersCompletenessField } from '../../components/partnersCompletenessField/PartnersCompletenessField'
import { SplitPlanningRow } from '../../components/splitPlanningRow/SplitPlanningRow'
import { SubCategoryMapRow } from '../../components/subCategoryMapRow/SubCategoryMapRow'
import {
  AIPC_CATEGORY,
  COMPLETENESS_INFO_FIN_SOB_PLAN_FIELD,
  CONTRACTUAL_CATEGORY,
  DISPLAY_OPTIONS,
  FIN_FRACTION_DIGITS_ROUNDING,
  GLOBAL_TOTAL_CATEGORY,
  HIDE_SOB_FOR_COUNTRY,
  MANDATORY_CATEGORY,
  MANDATORY_CATEGORY_ALWAYS_EXPANDED,
  OVERALL_CATEGORY,
  P360_FIRST_FYEAR,
  PLAN_REQUEST_FOR_PREV_YEARS,
  PLAN_SECTION_KEY,
  PLANNING_BY_FY_FQ,
  PLANNING_COL_NUMBER,
  PLANNING_URL_DEPS,
  PlanningRounding,
  POLY_CATEGORY,
  POLY_SUB_CATEGORIES,
  ROOM_CATEGORY,
  ROUNDING_VALUES,
  SOB_DETAILS_MANDATORY_CATEGORIES,
  SOB_DETAILS_MANDATORY_OFFERINGS,
  SOB_FRACTION_DIGITS,
  SOB_NEW_LOGIC_FYEAR,
  SST_MANDATORY_LOGIC_FYEAR,
} from '../../config'
import { ConfirmNotApplicableDialog } from '../../dialogs/confirmNotApplicableDialog/ConfirmNotApplicableDialog'
import { ConfirmPolyPlanningLevelDialog } from '../../dialogs/confirmPolyPlanningLevelDialog/ConfirmPolyPlanningLevelDialog'
import { ConfirmSwitchersChangeDialog } from '../../dialogs/confirmSwitchersChangeDialog/ConfirmSwitchersChangeDialog'
import { EditCommentDialog } from '../../dialogs/editCommentDialog/EditCommentDialog'
import { PartnersCompletenessDialog } from '../../dialogs/partnersCompletenessDialog/PartnersCompletenessDialog'
import { calcDiff } from '../../helpers/calcDiff'
import { calcPercentage } from '../../helpers/calcPercentage'
import { calcSoBCategoryOverallForCategory } from '../../helpers/calcSoBOverallForCategory'
import { checkFinSobRate } from '../../helpers/checks/checkFinSobRate'
import { checkFinSobValues } from '../../helpers/checks/checkFinSobValues'
import { ICheckFinSobValues } from '../../helpers/checks/models'
import { cleanQuartersAndFY } from '../../helpers/cleanQuartersAndFY'
import { getCategoryNAField } from '../../helpers/getCategoryNAField'
import { getCompletenessItem } from '../../helpers/getCompletenessItem'
import { getFieldName } from '../../helpers/getFieldName'
import { getFinSobValue, IGetFinSobValueProps } from '../../helpers/getFinSobValue'
import { getIsCollapsedCategory } from '../../helpers/getIsCollapsedCategory'
import { getIsCollapsedL3Category } from '../../helpers/getIsCollapsedL3Category'
import { getNAField } from '../../helpers/getNAField'
import { getPartnerFlags } from '../../helpers/getPartnerFlags'
import { getPlanValue } from '../../helpers/getPlanValue'
import { getRestoredValue, getRoundedValue } from '../../helpers/getRoundedValue'
import { getRoundingField } from '../../helpers/getRoundingField'
import { getIsExpandedByFlags } from '../../helpers/partnerFlags/getIsExpandedByFlags'
import { isContractualsByFlag } from '../../helpers/partnerFlags/isContractualsByFlag'
import { isPartnerFlagActive } from '../../helpers/partnerFlags/isPartnerFlagActive'
import {
  IPreparePlanningItems,
  preparePlanningItems,
} from '../../helpers/prepareData/preparePlanningItems'
import { setFySobByQuarters } from '../../helpers/setFySobByQuarters'
import { setFYTotalByQuarters } from '../../helpers/setFYTotalByQuarters'
import { setItemValuesUniversal } from '../../helpers/setItemValuesUniversal'
import { setQuarterByFYTotal } from '../../helpers/setQuarterByFYTotal'
import { TSettingsSuffix, TSplitType, TSType } from '../../models'
import { CustomFields } from '../../models/CustomFields'
import { IFieldProps } from '../../models/IFieldProps'
import { IFinSobValidationError } from '../../models/IFinSobValidationError'
import { IPartnersCompleteness } from '../../models/IPartnersCompleteness'

import { RetailCategoryHeader } from './components/retailCaption/RetaiCategoryHeaders'
import { RetailCategoryTitle } from './components/retailTitle/RetailCategoryTitle'
import { ViewField } from './components/viewField/ViewField'
import {
  actualsColor,
  IS_ALWAYS_SHOW_ACTUALS,
  IS_ALWAYS_SHOW_SOB,
  IS_ENABLE_ROUNDING,
  IS_NEW_LNF,
  IS_QUARTER_DEFAULT,
  IS_RECALC_SOB,
  IS_SHOW_COMPOSED_REPORT_EXPANDED_WARNING,
  IS_SHOW_CY_ACTUALS_COLUMNS,
  IS_SHOW_NOT_APPLICABLE,
  IS_SHOW_PARTNERS_COMPLETENESS_FOR_ALL_ROWS,
  IS_SHOW_PARTNERS_COMPLETENESS_FOR_SUB_CATEGORIES,
  IS_SHOW_PREV_RECALC_ACTUALS,
  IS_USE_LEVEL_ICON,
} from './config'
import { IRetailFinSobProps } from './models/IRetailFinSobProps'

import styles from './RetailFinSob.module.scss'
import stylesCompensation from 'legacy/lut/components/widgets/public/partner360/Compensation.module.scss'
import stylesTable from 'legacy/lut/components/widgets/public/partner360/PartnerDevicesInfo.module.scss'

interface ISetFinSobParams {
  settingsIndex: number
  value: string | null
  type: 'actuals' | 'targets' | 'quota'
  fy: number
  fq: number
  isUnits: boolean
  isOverall: boolean
  sType: TSType
  isSoB: boolean
  isNoSplit: boolean
  itemsForUpdate?: IJBPPlanningItem[]
  isCleanChild?: boolean
  sTypeOriginal?: TSType
  isNotManual?: boolean
}

interface ICommentEditor {
  index: number
  year: number
  q: number
  comment: string
}

export const RetailFinSob = (props: IRetailFinSobProps) => {
  /** -------------------- States ----------------------- */

  const [actualsItems, setActualsItems] = useState<IJBPPlanningItem[]>([])
  const [actualsNoSplitItems, setActualsNoSplitItems] = useState<IJBPPlanningItem[]>([])
  const [editCommentEditor, setCommentEditor] = useState<ICommentEditor>()
  const [isChangeApplying, setIsChangeApplying] = useState(false)
  const [isCollapseAllowed, setIsCollapseAllowed] = useState<boolean>(true)
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true)
  const [isDataPresent, setIsDataPresent] = useState(false)
  const [, setIsUnitsMandatory] = useState<boolean>(false)
  const [hideIfEmpty, setHideIfEmpty] = useState(false)
  const [quotaItems, setQuotaItems] = useState<IJBPPlanningItem[]>([])
  const [reservedActuals, setReservedActuals] = useState<IJBPPlanningItem[]>([])
  const [reservedTargets, setReservedTargets] = useState<IJBPPlanningItem[]>([])
  const [targetsItems, setTargetsItems] = useState<IJBPPlanningItem[]>([])
  const [targetsNoSplitItems, setTargetsNoSplitItems] = useState<IJBPPlanningItem[]>([])
  const [actualsRollupItems, setActualsRollupItems] = useState<IJBPPlanningItem[]>([])
  const [targetsRollupItems, setTargetsRollupItems] = useState<IJBPPlanningItem[]>([])
  const [actualsPartnerCountItems, setActualsPartnerCountItems] = useState<IJBPPlanningItem[]>([])

  const [validationErrors, setValidationErrors] = useState<IFinSobValidationError[]>([])
  const [, setValidationInputIndex] = useState(0)
  const [, setValidationInputUnconfirmedCount] = useState(0)

  const [isRecalcPlans] = useState(false)
  const [isShowAllSplits, setIsShowAllSplits] = useState(false)
  const [isShowConfirmNotApplicableDialog, setIsShowConfirmNotApplicableDialog] = useState(false)
  const [isShowConfirmSwitchersChangeDialog, setIsShowConfirmSwitchersChangeDialog] =
    useState(false)
  const [isShowComposedSoB, setIsShowComposedSoB] = useState(false)
  const [isShowOnlyCompletedPlans] = useState(true)
  const [isShowRateDialog, setIsShowRateDialog] = useState(false)
  const [isShowSignDialog, setIsShowSignDialog] = useState(false)
  const [isShowSignDialogNA, setIsShowSignDialogNA] = useState(false)
  const [polyPlanningLevel, setPolyPlanningLevel] = useState('')
  const [partnersCompleteness, setPartnersCompleteness] = useState<IPartnersCompleteness>()
  const [splitType, setSplitType] = useState<TSplitType>('Total')
  const [validationStatus, setValidationStatus] = useState(ValidationStatus.Invalid)
  const [l3CollapsedFlags, setL3CollapsedFlags] = useState<Record<number, number>>({})

  /** -------------------- Selectors ----------------------- */

  const { isDistributor, isRegionalDistributor } = useSelector(selectPartnerAccess)
  const sectionSettings = useSelector(selectSectionSettings)
  const isEditMode = useSelector(selectPublishingMode)

  /** -------------------- Hooks ----------------------- */

  const dispatch = useAppDispatch()
  const context = useContext(URLContext)
  const t = useSafetyTranslation()
  const partnerId = usePartnerId(props.widgetParams, props.pid)
  const {
    fyear: partnerFYear,
    partnerInfo,
    canEditPartner,
    buttonCurrType,
  } = usePartnerInfo({ partnerId })

  const changeNotApplicableHndl = useChangeNotApplicable({
    partnerId,
    fYear: partnerFYear,
  })

  const { jbpSettings } = useJbpSettings()
  const isFinSobPlanQuarterlyChecksEnabled = !!jbpSettings.finSobPlanQuarterlyChecks

  const fixedComposedReportFYear = props.composedReportFYear ?? jbpSettings.currentFYear
  const fixedQuarterlyBusinessReviewFYear =
    props.quarterlyBusinessReviewFYear ?? jbpSettings.currentFYear
  const composedReportFYear = props.composedReportMode ? fixedComposedReportFYear : partnerFYear
  const fyear = props.isQuarterlyBusinessReviewMode
    ? fixedQuarterlyBusinessReviewFYear
    : composedReportFYear
  const { activeCurrency: partnerCurrency } = useCurrencies()

  const { actualsType, actualsTypes, onChangeActualsType } = useActualsTypes()

  const { signed, dropSignature } = GetSignatureId(
    partnerId,
    COMPLETENESS_INFO_FIN_SOB_PLAN_FIELD,
    buttonCurrType
  )

  /** -------------------- Variables ----------------------- */

  const {
    isYearlyPlanning,
    isShowDetailedPlanning,
    isShowPreviousPlans: isShowPrevTargets,
  } = props.displaySettings.settings

  const currentCat = useMemo(() => props.dataSetInfo.category, [props.dataSetInfo.category])
  const categoryName = useMemo(() => t(props.dataSetInfo.category), [props.dataSetInfo.category, t])

  const isRetailer = useMemo(() => buttonCurrType === ProgramTypes.Retail, [buttonCurrType])

  const isQuarterDefaultOn = useMemo(() => {
    return IS_QUARTER_DEFAULT && !isRetailer
  }, [isRetailer])

  const isOnlyQuarterlyPlanning = useMemo(() => {
    return !!props.dataSetInfo.IsOnlyQuarterlyPlanning && jbpSettings.currentFYear === fyear
  }, [fyear, jbpSettings.currentFYear, props.dataSetInfo.IsOnlyQuarterlyPlanning])

  const isSobDetailsMandatory = useMemo(() => {
    // Retail SOB
    if (
      SOB_DETAILS_MANDATORY_OFFERINGS.includes(buttonCurrType) ||
      SOB_DETAILS_MANDATORY_CATEGORIES.includes(currentCat)
    ) {
      return true
    }

    const flags = props.partnerFlagsState
    const cat = currentCat
    const formats = props.formats
    const isSobFlagsEnabledInSubCat = isPartnerFlagActive(flags, formats, cat, false, false, true)

    return isSobFlagsEnabledInSubCat
  }, [buttonCurrType, currentCat, props.partnerFlagsState, props.formats])

  const isAlwaysExpanded = useMemo(() => {
    return currentCat === ROOM_CATEGORY || currentCat === AIPC_CATEGORY
  }, [currentCat])

  const currency = useMemo(() => {
    const qbrCurrency = props.quarterlyBusinessReviewCurrency || 'USD'

    return !props.isQuarterlyBusinessReviewMode ? partnerCurrency : qbrCurrency
  }, [partnerCurrency, props.isQuarterlyBusinessReviewMode, props.quarterlyBusinessReviewCurrency])

  const currentValueType = useMemo(() => {
    let calcualtedValueType = actualsType

    if (props.isQuarterlyBusinessReviewMode) {
      calcualtedValueType =
        (props.quarterlyBusinessReviewNetNdp as ActualsValueTypes) || ActualsValueTypes.Ndp
    }

    return calcualtedValueType
  }, [actualsType, props.isQuarterlyBusinessReviewMode, props.quarterlyBusinessReviewNetNdp])

  const isTargetsChanged = useMemo(
    () => targetsItems.some((el) => !!el.IsChanged || !!el.IsChangedSoB),
    [targetsItems]
  )
  const isTargetsValuesChanged = useMemo(
    () => targetsItems.some((el) => !!el.IsChanged),
    [targetsItems]
  )
  const isActualsChanged = useMemo(
    () => actualsItems.some((el) => !!el.IsChanged || !!el.IsChangedSoB),
    [actualsItems]
  )
  const isDataChanged = useMemo(
    () => isTargetsChanged || isActualsChanged,
    [isActualsChanged, isTargetsChanged]
  )
  const isShowUnits = useMemo(
    () => !!props.dataSetInfo.IsUnitsAvailable,
    [props.dataSetInfo.IsUnitsAvailable]
  )
  const catNAField = useMemo(() => getCategoryNAField(currentCat), [currentCat])
  const isOverallOnly = useMemo(
    () =>
      !props.formats.filter((el) => !!el.SubCategory && el.SubCategory !== OVERALL_CATEGORY).length,
    [props.formats]
  )
  const isTargetsNotChanged = useMemo(
    () =>
      JSON.stringify(
        targetsItems.map((el) => {
          return { ...el, IsChanged: 0, IsChangedSoB: 0 }
        })
      ) ===
      JSON.stringify(
        reservedTargets.map((el) => {
          return { ...el, IsChanged: 0, IsChangedSoB: 0 }
        })
      ),
    [reservedTargets, targetsItems]
  )
  const isTargetsSignedNotChanged = useMemo(
    () =>
      JSON.stringify(
        targetsItems.map((el) => {
          return { ...el, IsChanged: 0, IsChangedSoB: 0, Comment: '' }
        })
      ) ===
      JSON.stringify(
        reservedTargets.map((el) => {
          return { ...el, IsChanged: 0, IsChangedSoB: 0, Comment: '' }
        })
      ),
    [reservedTargets, targetsItems]
  )
  const isActualsNotChanged = useMemo(
    () =>
      JSON.stringify(
        actualsItems.map((el) => {
          return { ...el, IsChanged: 0, IsChangedSoB: 0 }
        })
      ) ===
      JSON.stringify(
        reservedActuals.map((el) => {
          return { ...el, IsChanged: 0, IsChangedSoB: 0 }
        })
      ),
    [actualsItems, reservedActuals]
  )
  const isNotChanged = useMemo(
    () => isTargetsNotChanged && isActualsNotChanged,
    [isActualsNotChanged, isTargetsNotChanged]
  )
  const isTargetSignedChanged = useMemo(
    () => isTargetsChanged && !isTargetsSignedNotChanged,
    [isTargetsChanged, isTargetsSignedNotChanged]
  )
  const isNeedToShowSignNADialog = useMemo(() => signed > -1, [signed])
  const isNeedToShowSignDialog = useMemo(
    () => isNeedToShowSignNADialog && isTargetSignedChanged,
    [isNeedToShowSignNADialog, isTargetSignedChanged]
  )
  const isTargetValuesReallyChanged = useMemo(
    () => isTargetsValuesChanged && !isTargetsNotChanged,
    [isTargetsNotChanged, isTargetsValuesChanged]
  )
  const isHideSoB = useMemo(
    () => partnerInfo?.CountryCode === HIDE_SOB_FOR_COUNTRY,
    [partnerInfo?.CountryCode]
  )
  const { isPartnerUser } = useUserRoles()

  const isCurrencyChanged = useMemo(
    () => !!props.originalCurrency && props.originalCurrency !== currency,
    [currency, props.originalCurrency]
  )
  const isActualsValueTypeChanged = useMemo(
    () => !!props.originalActualsValueType && props.originalActualsValueType !== currentValueType,
    [currentValueType, props.originalActualsValueType]
  )

  const isSwitchersChanged = useMemo(
    () => isTargetValuesReallyChanged && (isCurrencyChanged || isActualsValueTypeChanged),
    [isActualsValueTypeChanged, isCurrencyChanged, isTargetValuesReallyChanged]
  )

  const isFixedCollapsed = isCollapsed

  const isNotApplicableAllowed = useMemo(
    () =>
      props.dataSetInfo.MandatoryType !== MANDATORY_CATEGORY &&
      props.dataSetInfo.MandatoryType !== MANDATORY_CATEGORY_ALWAYS_EXPANDED,
    [props.dataSetInfo.MandatoryType]
  )

  const applyButtonKey = useMemo(
    () => (isFixedCollapsed ? 'jbp-hr-save-overall' : 'jbp-hr-save-details'),
    [isFixedCollapsed]
  )

  const isEditAllowed = useMemo(
    () =>
      !props.readOnly &&
      isEditMode &&
      !props.composedReportMode &&
      !props.isQuarterlyBusinessReviewMode &&
      canEditPartner &&
      (!isRegionalDistributor || props.isRegionalPlanning) &&
      (!props.globalCategory || !!props.globalCategory.IsEditable) &&
      actualsType !== ActualsValueTypes.UTNet,
    [
      actualsType,
      canEditPartner,
      isEditMode,
      isRegionalDistributor,
      props.composedReportMode,
      props.globalCategory,
      props.isQuarterlyBusinessReviewMode,
      props.isRegionalPlanning,
      props.readOnly,
    ]
  )

  const shortPrevFY = useMemo(() => (fyear || 2000) - 2001, [fyear])
  const showPrevTargetsParams = useMemo(
    () => [{ key: '{prevFY}', value: shortPrevFY.toString() }],
    [shortPrevFY]
  )

  const isShowCurrencyCtrl = useMemo(
    () => !props.dataSetInfo.Settings?.HideCurrencyCtrl && !props.composedReportMode,
    [props.composedReportMode, props.dataSetInfo.Settings?.HideCurrencyCtrl]
  )
  const isShowNetNdpCtrl = useMemo(
    () => !props.dataSetInfo.Settings?.HideNetNdpCtrl && !props.composedReportMode,
    [props.composedReportMode, props.dataSetInfo.Settings?.HideNetNdpCtrl]
  )
  const isShowActualsCtrl = useMemo(
    () => !props.dataSetInfo.Settings?.HideActualsCtrl && !props.composedReportMode,
    [props.composedReportMode, props.dataSetInfo.Settings?.HideActualsCtrl]
  )
  const isShowQuotaCtrl = useMemo(
    () =>
      !IS_NEW_LNF &&
      !props.dataSetInfo.Settings?.HideQuotaCtrl &&
      !props.composedReportMode &&
      !props.isQuarterlyBusinessReviewMode,
    [
      props.composedReportMode,
      props.dataSetInfo.Settings?.HideQuotaCtrl,
      props.isQuarterlyBusinessReviewMode,
    ]
  )
  const isShowCurrencyBlock = useMemo(
    () => !props.dataSetInfo.Settings?.HideCurrencyBlock,
    [props.dataSetInfo.Settings?.HideCurrencyBlock]
  )
  const isShowSalesTypeCtrl = useMemo(
    () =>
      !props.dataSetInfo.Settings?.HideSalesTypeCtrl &&
      !props.composedReportMode &&
      !props.isEltMode,
    [props.composedReportMode, props.dataSetInfo.Settings?.HideSalesTypeCtrl, props.isEltMode]
  )

  const isShowPrevTargetsCtrl = useMemo(
    () => !IS_NEW_LNF && !props.isQuarterlyBusinessReviewMode,
    [props.isQuarterlyBusinessReviewMode]
  )

  const isShowCtrlBeforeActuals = useMemo(
    () => isShowCurrencyCtrl || isShowNetNdpCtrl,
    [isShowCurrencyCtrl, isShowNetNdpCtrl]
  )
  const isShowActualsCtrlFirst = useMemo(
    () => !isShowCtrlBeforeActuals && isShowActualsCtrl,
    [isShowActualsCtrl, isShowCtrlBeforeActuals]
  )
  const isShowDistributorCtrlFirst = useMemo(
    () => !isShowCtrlBeforeActuals && !isShowActualsCtrl && !isShowQuotaCtrl,
    [isShowActualsCtrl, isShowCtrlBeforeActuals, isShowQuotaCtrl]
  )

  const isOveralledCategory = useMemo(
    () =>
      props.formats.length === 1 &&
      !props.formats.some((el) => el.SubCategory === OVERALL_CATEGORY),
    [props.formats]
  )
  const isShowComposedReportCollapsedWarning = useMemo(
    () =>
      IS_SHOW_COMPOSED_REPORT_EXPANDED_WARNING &&
      props.composedReportMode &&
      !isRecalcPlans &&
      !isFixedCollapsed &&
      !isOveralledCategory,
    [isFixedCollapsed, isOveralledCategory, isRecalcPlans, props.composedReportMode]
  )

  const isMandatoryByFlagLogic = useMemo(() => fyear >= SST_MANDATORY_LOGIC_FYEAR, [fyear])
  const isSoBNewLogic = useMemo(() => fyear >= SOB_NEW_LOGIC_FYEAR, [fyear])

  // Show PrevFY and Cals Actuals logic
  const isShowCalcActuals = useMemo(
    () =>
      IS_SHOW_PREV_RECALC_ACTUALS &&
      fyear > jbpSettings.fYear &&
      jbpSettings.currentFQuarter === 4 &&
      !props.composedReportMode,
    [fyear, jbpSettings.currentFQuarter, jbpSettings.fYear, props.composedReportMode]
  )
  const planningColSpan = useMemo(
    () => PLANNING_COL_NUMBER + (isShowCalcActuals ? 1 : 0),
    [isShowCalcActuals]
  )

  const isUseContractuals = useMemo(() => {
    const flags = partnerInfo?.PartnerFlags || ''
    const isContrByFlag = isContractualsByFlag(flags, props.partnerFlagsState)
    const isStandartContractualPlanning =
      buttonCurrType === ProgramTypes.CorePrint &&
      currentCat === CONTRACTUAL_CATEGORY &&
      (props.isContractualPlanning || isContrByFlag)

    const isDistributorExtendedPlanning =
      props.isDistributorPlanner && !!jbpSettings.distributorExtendedPlanning

    return props.isDistributorPlanner
      ? isDistributorExtendedPlanning
      : isStandartContractualPlanning
  }, [
    partnerInfo?.PartnerFlags,
    props.partnerFlagsState,
    props.isContractualPlanning,
    props.isDistributorPlanner,
    buttonCurrType,
    currentCat,
    jbpSettings.distributorExtendedPlanning,
  ])

  const isNoSplitPlans = useMemo(
    () => !isUseContractuals || splitType === 'Total',
    [isUseContractuals, splitType]
  )

  // Category title and tip keys
  const offeringName = useMemo(
    () => buttonCurrType || props.dataSetInfo.ProgramType,
    [buttonCurrType, props.dataSetInfo.ProgramType]
  )
  const offeringNameLower = useMemo(
    () => offeringName.replace(/\s/g, '').toLowerCase(),
    [offeringName]
  )
  const currentCatLower = useMemo(() => currentCat.replace(/\s/g, '').toLowerCase(), [currentCat])

  const globalCategoryKey = useMemo(() => {
    let key = props.globalCategory?.GlobalCategory
    if (
      props.globalCategory &&
      !!props.globalCategory.GlobalSubCategory &&
      props.globalCategory.GlobalSubCategory !== OVERALL_CATEGORY &&
      props.globalCategory.GlobalSubCategory !== GLOBAL_TOTAL_CATEGORY
    ) {
      key = props.globalCategory.GlobalSubCategory
    }

    return key
  }, [props.globalCategory])

  const globalShortKey = useMemo(() => {
    const key = (globalCategoryKey || '').replace(/jbp-/g, '')

    return !key ? `jbp-${offeringNameLower}` : `jbp-${offeringNameLower}-${key}`
  }, [globalCategoryKey, offeringNameLower])

  const globalKey = useMemo(
    () => `${globalShortKey}-${currentCatLower}`,
    [currentCatLower, globalShortKey]
  )
  const headerKey = useMemo(
    () => (!partnerInfo?.IsGlobal ? currentCat : globalKey),
    [currentCat, globalKey, partnerInfo?.IsGlobal]
  )
  const globalCategoryTipPrefix = useMemo(
    () => (!partnerInfo?.IsGlobal ? '' : globalShortKey),
    [globalShortKey, partnerInfo?.IsGlobal]
  )

  // Header key
  const headerComposedSuffix = useMemo(
    () => (props.composedReportMode ? '-composed' : '-editor'),
    [props.composedReportMode]
  )
  const headerSuffix = useMemo(
    () => (props.isQuarterlyBusinessReviewMode ? '-qbr' : headerComposedSuffix),
    [headerComposedSuffix, props.isQuarterlyBusinessReviewMode]
  )
  const categoryHeaderKey = useMemo(() => `${headerKey}${headerSuffix}`, [headerKey, headerSuffix])
  const isShowMapRow = useMemo(() => {
    return !isPartnerUser && !props.composedReportMode && !props.isQuarterlyBusinessReviewMode
  }, [isPartnerUser, props.composedReportMode, props.isQuarterlyBusinessReviewMode])

  const isShowFutureYears = useMemo(() => {
    return (
      props.isShowFutureYearsPlans &&
      fyear > 2024 &&
      (!props.isQuarterlyBusinessReviewMode || !!props.isEltMode)
    )
  }, [fyear, props.isEltMode, props.isQuarterlyBusinessReviewMode, props.isShowFutureYearsPlans])

  const isExistControlsAfterRounding = useMemo(
    () =>
      (isShowActualsCtrl && !IS_ALWAYS_SHOW_ACTUALS) ||
      isShowQuotaCtrl ||
      (isDistributor && isRegionalDistributor) ||
      isShowPrevTargetsCtrl,
    [
      isDistributor,
      isRegionalDistributor,
      isShowActualsCtrl,
      isShowPrevTargetsCtrl,
      isShowQuotaCtrl,
    ]
  )

  /** -------------------- Methods ----------------------- */

  const generateTranslationKey = useCallback((option: string) => {
    const suffix = option.trim().replace(/\s/g, '').toLowerCase()

    return `${PLAN_SECTION_KEY}-displaymode-${suffix}`
  }, [])

  const { updatePendingData, registrUrlDeps } = useTargetsUrlDeps({
    resetChanged: () => {
      setTargetsItems(reservedTargets)
      setActualsItems(reservedActuals)
    },
    apply: () => {
      applyChangesHandler()
    },
    changed: isDataChanged,
    isNotChanged,
    urlDeps: PLANNING_URL_DEPS,
    isCancelIfChanged: true,
  })

  registrUrlDeps(context)

  const getL3Index = (format: IFormActualsTargetsSettings) => {
    let idx = 0
    let subCategory = ''
    let isFormatFound = false

    props.formats
      .filter((el) => !!el.L3Category)
      .filter((el) => el.Category === format.Category)
      .forEach((el) => {
        if (subCategory !== el.SubCategory && !isFormatFound) {
          subCategory = el.SubCategory
          if (el.SubCategory === format.SubCategory) {
            isFormatFound = true
          } else {
            idx++
          }
        }
      })

    return idx
  }

  const isCategoryNA = useMemo(() => {
    let isNotApplicable = isNotApplicableAllowed

    if (partnerInfo) {
      const sectionSetting = sectionSettings[catNAField]
      if (sectionSetting == undefined || sectionSetting == null) {
        // sectionSettings Not defined
        if (hideIfEmpty && !isDataPresent) {
          return true
        } else {
          // Not hideIfEmpty or dataPresent > use Original behave
          isNotApplicable = isNotApplicable && isSectionSettingOn(sectionSetting)
        }
      } else {
        // sectionSettings defined > use Original behave
        isNotApplicable = isNotApplicable && isSectionSettingOn(sectionSetting)
      }
    }

    return (
      !IS_SHOW_NOT_APPLICABLE &&
      isNotApplicable &&
      !props.composedReportMode &&
      !props.isQuarterlyBusinessReviewMode
    )
  }, [
    catNAField,
    sectionSettings,
    hideIfEmpty,
    isDataPresent,
    isNotApplicableAllowed,
    partnerInfo,
    props.composedReportMode,
    props.isQuarterlyBusinessReviewMode,
  ])

  const isShowNotApplicableMessage = useMemo(() => {
    return !IS_SHOW_NOT_APPLICABLE && isNotApplicableAllowed && isCategoryNA
  }, [isNotApplicableAllowed, isCategoryNA])

  const isShowNotApplicableWidget = useMemo(() => {
    return IS_SHOW_NOT_APPLICABLE && isNotApplicableAllowed
  }, [isNotApplicableAllowed])

  const isOn = (key: string, type: TSettingsSuffix, defaultValue: boolean = false) => {
    let settingValue = defaultValue

    if (partnerInfo) {
      const field = getNAField(key, type)
      const val = sectionSettings[field]
      if (val !== undefined && val !== null) {
        settingValue = isSectionSettingOn(val)
      }
    }

    return settingValue
  }

  const isShowApplySection = !isCategoryNA && isEditAllowed
  const isShowQbrUnits =
    !!props.isQuarterlyBusinessReviewMode && !!props.isQuarterlyBusinessReviewUnits
  const isShowUnitsOnPlanning = isShowUnits && !isCategoryNA && isOn(currentCat, 'units')
  const isShowUnitsSection =
    isShowUnitsOnPlanning || isShowQbrUnits || !!props.dataSetInfo.IsHideFinancial
  const isShowPlanningSection =
    !props.dataSetInfo.IsHideFinancial &&
    (!props.isQuarterlyBusinessReviewMode || !props.isQuarterlyBusinessReviewUnits)
  const isShowApplyBeforeUnits = isShowApplySection && isShowUnitsSection && isShowPlanningSection

  const preparePlanningData = useCallback(async () => {
    dispatch(changeFinSobIsCategoryPlanningDataLoading(true))

    setValidationStatus(ValidationStatus.Valid)

    const isComposedReport = !!props.composedReportMode
    const isQuarterlyBusinessReview = !!props.isQuarterlyBusinessReviewMode

    let filteredData = props.planningData.filter(
      (el) =>
        (el.ProgramTypes === buttonCurrType || isComposedReport || isQuarterlyBusinessReview) &&
        el.Category === currentCat &&
        !el.IsTotal &&
        (!props.globalCategory || el.GlobalCategory === globalCategoryKey)
    )

    const isIgnorePartnerId = !!props.composedReportMode || !!props.isQuarterlyBusinessReviewMode

    if (!isIgnorePartnerId) {
      // Show distributor's group data for Regional Distributor:
      // Get data from all Partner in group, Except Regional Distributor
      if (isRegionalDistributor && !props.isRegionalPlanning) {
        filteredData = filteredData.filter((el) => el.PartnerId !== partnerId)
      } else {
        filteredData = filteredData.filter((el) => el.PartnerId === partnerId)
      }
    }

    // Separation into Target, Actuals, Quota data
    const rawTargets = filteredData.filter(
      (el) =>
        !!el.IsTarget && (!isComposedReport || !el.IsNoSplit) && !el.IsRollUp && !el.IsPartnerCount
    )
    const rawActuals = filteredData.filter(
      (el) =>
        !!el.IsActuals && (!isComposedReport || !el.IsNoSplit) && !el.IsRollUp && !el.IsPartnerCount
    )
    const rawQuota = filteredData.filter(
      (el) =>
        !!el.IsQuota && (!isComposedReport || !el.IsNoSplit) && !el.IsRollUp && !el.IsPartnerCount
    )
    // Separation into NoSplit, RollUp, PartnerCount data
    const rawTargetsNoSplit = filteredData.filter(
      (el) => !!el.IsNoSplit && !!el.IsTarget && !el.IsRollUp && !el.IsPartnerCount
    )
    const rawActualsNoSplit = filteredData.filter(
      (el) => !!el.IsNoSplit && !!el.IsActuals && !el.IsRollUp && !el.IsPartnerCount
    )
    const rawTargetsRollup = filteredData.filter((el) => !!el.IsRollUp && !!el.IsTarget)
    const rawActualsRollup = filteredData.filter((el) => !!el.IsActuals && !!el.IsRollUp)
    const rawActualsPartnerCount = filteredData.filter(
      (el) => !!el.IsPartnerCount && !!el.IsActuals
    )

    const futureYears = isShowFutureYears ? 2 : 0
    const lastFYear = fyear + futureYears

    const commonParams: IPreparePlanningItems = {
      planningSettings: props.formats,
      source: rawTargets,
      partnerId: partnerId,
      fyear: fyear,
      lastFYear: lastFYear,
      isActuals: 0,
      isDirect: 0,
      isTarget: 1,
      isQuota: 0,
      isComposedReport: isComposedReport,
      isNoSplit: 0,
      isRollUp: 0,
      isTotal: 0,
      isPartnerCount: 0,
      globalCategory: globalCategoryKey,
    }

    // Prepare Target, Actuals, Quota data
    const targetsItems = preparePlanningItems(commonParams)
    const actualsItems = preparePlanningItems({
      ...commonParams,
      source: rawActuals,
      isTarget: 0,
      isActuals: 1,
    })
    const quotaItems = preparePlanningItems({
      ...commonParams,
      source: rawQuota,
      isTarget: 0,
      isQuota: 1,
    })
    // Prepare NoSplit, RollUp, PartnerCount data
    const actualsNoSplitItems = preparePlanningItems({
      ...commonParams,
      source: rawActualsNoSplit,
      isTarget: 0,
      isActuals: 1,
      isNoSplit: 1,
    })
    const targetsNoSplitItems = preparePlanningItems({
      ...commonParams,
      source: rawTargetsNoSplit,
      isNoSplit: 1,
    })
    const targetsRollupItems = preparePlanningItems({
      ...commonParams,
      source: rawTargetsRollup,
      isRollUp: 1,
    })
    const actualsRollupItems = preparePlanningItems({
      ...commonParams,
      source: rawActualsRollup,
      isTarget: 0,
      isActuals: 1,
      isRollUp: 1,
    })
    const actualsPartnerCountItems = preparePlanningItems({
      ...commonParams,
      source: rawActualsPartnerCount,
      isTarget: 0,
      isActuals: 1,
      isPartnerCount: 1,
    })

    setTargetsItems(targetsItems)
    setActualsItems(actualsItems)
    setQuotaItems(quotaItems)
    setActualsNoSplitItems(actualsNoSplitItems)
    setTargetsNoSplitItems(targetsNoSplitItems)
    setTargetsRollupItems(targetsRollupItems)
    setActualsRollupItems(actualsRollupItems)
    setActualsPartnerCountItems(actualsPartnerCountItems)

    setReservedTargets([
      ...targetsItems.map((el) => {
        return { ...el }
      }),
    ])
    setReservedActuals([
      ...actualsItems.map((el) => {
        return { ...el }
      }),
    ])

    if (rawTargets.filter((el) => el.FYear === fyear).length) {
      const isCollapsedCategory = getIsCollapsedCategory(targetsItems, fyear)
      setIsCollapsed(isCollapsedCategory && isCollapseAllowed)
    }

    // Begin: calculate hideIfEmpty, dataNotEmpty
    let hideEmptyData: boolean = false
    if (props.formats) {
      props.formats.map((el) => {
        if (!!el.HideIfEmpty && !hideIfEmpty) {
          setHideIfEmpty(true)
          hideEmptyData = true
        }
      })
    }

    if (hideEmptyData) {
      let isDataPresent = false
      targetsItems.map((el) => {
        if (el.IsDataPresent) {
          isDataPresent = true
        }
      })
      setIsDataPresent(isDataPresent)
    }
    // End: calculate hideIfEmpty, dataNotEmpty

    dispatch(changeFinSobIsCategoryPlanningDataLoading(false))
  }, [
    dispatch,
    props.composedReportMode,
    props.isQuarterlyBusinessReviewMode,
    props.planningData,
    props.formats,
    props.globalCategory,
    props.isRegionalPlanning,
    isShowFutureYears,
    fyear,
    partnerId,
    globalCategoryKey,
    buttonCurrType,
    currentCat,
    isRegionalDistributor,
    isCollapseAllowed,
    hideIfEmpty,
  ])

  /**
   * Is Overall Value for Current FY Exist and Not changed
   */
  const isOverallValueNotChanged = (partnerInfo: IFormPartnerBasicInfo | undefined): boolean => {
    let isNotChanged = false

    if (partnerInfo) {
      const valueTypeSuffix = currentValueType.toLowerCase() === 'ndp' ? 'Ndp' : 'Net'
      const currencySuffix = !currency || currency === 'USD' ? 'Usd' : 'Lc'
      const originalValueField = `OfficeHWPlan${valueTypeSuffix}${currencySuffix}`
      const originalValue = partnerInfo[originalValueField]
      if (originalValue || originalValue === 0) {
        const overallSettings = props.formats.filter(
          (el) =>
            el.ProgramType === buttonCurrType &&
            el.Category === currentCat &&
            (!el.SubCategory || el.SubCategory === OVERALL_CATEGORY)
        )
        if (overallSettings.length) {
          const overallSetting = overallSettings[0]

          const sType = '' // Total
          const fq = 5 // FY Value
          const isUnits = false
          const isSoB = false
          const isDirect = false

          const newValue = getPlanValue(
            overallSetting,
            targetsItems,
            partnerId,
            fyear,
            fq,
            currentValueType,
            isUnits,
            currency,
            isFixedCollapsed,
            sType,
            isSoB,
            isDirect,
            isShowOnlyCompletedPlans,
            isShowComposedSoB,
            isRecalcPlans,
            props.composedReportMode,
            props.isQuarterlyBusinessReviewMode
          )

          if (newValue === originalValue) {
            isNotChanged = true
          }
        }
      }
    }

    return isNotChanged
  }

  const applyChanges = async (
    targetsData: IJBPPlanningItem[],
    actualsData: IJBPPlanningItem[] | null = null
  ) => {
    dispatch(changeFinSobIsCategoryPlanningApplyingChangesLoading(true))
    setIsChangeApplying(true)
    let isPlanningSaved = false

    try {
      const fromFYear = Math.max(fyear - PLAN_REQUEST_FOR_PREV_YEARS, P360_FIRST_FYEAR)
      const isUSD = !currency || currency === 'USD'
      const cleanTargets = cleanPlanningItemForApi(targetsData, fyear, isFixedCollapsed)
      const cleanActuals = cleanPlanningItemForApi(
        actualsData ?? actualsItems,
        fyear,
        isFixedCollapsed
      )

      const isTargetsChanged = cleanTargets.some((el) => !!el.IsChanged || !!el.IsChangedSoB)
      const isActualsSobChanged = cleanActuals.some((el) => !!el.IsChangedSoB)
      const isMandatoryFiledsChanged = isTargetsChanged || isActualsSobChanged

      const cleanData = [...cleanTargets, ...cleanActuals]
      const json = JSON.stringify(cleanData)

      const isQuarterPlanning =
        !isYearlyPlanning &&
        (isOnlyQuarterlyPlanning || isOn(currentCat, 'quarter', isQuarterDefaultOn))

      const applyResponse = await applyJBPPlanning<IJBPPlanning>(
        partnerId,
        fyear,
        fromFYear,
        buttonCurrType,
        isQuarterPlanning,
        isUSD,
        currentValueType,
        isRegionalDistributor,
        json
      )
      isPlanningSaved = true

      if (partnerInfo?.IsGlobal) {
        dispatch(requestGlobalPartnerData({ partnerId, fYear: fyear }))
      }

      if (props.onApply) {
        const newData: IJBPPlanning[] = applyResponse?.Rows || []
        props.onApply(newData)
      }

      const isDropSignature =
        isTargetsChanged && signed > -1 && !isOverallValueNotChanged(partnerInfo)

      if (isDropSignature) {
        await dropSignature('Financial & SOB Targets')
      }

      if (isMandatoryFiledsChanged) {
        try {
          await dispatch(requestRecalculateCompleteness({ partnerId, fYear: fyear })).unwrap()
        } catch (error) {
          Logger.error(error)
          NotificationController.showWarning({
            message:
              'Planning data was saved, but completeness could not be updated. Please refresh the page later.',
          })
        }
      }

      const isRoundingNeedToSave =
        IS_ENABLE_ROUNDING && props.roundingValue !== props.roundingValueOriginal
      if (isRoundingNeedToSave) {
        // The value itself (AsIs | K | M) goes under the key that Planning reads.
        await dispatch(
          updateSectionSettings({
            flag: getRoundingField(buttonCurrType),
            state: props.roundingValue || PlanningRounding.AsIs,
            controlName: 'Planning',
          })
        )
      }

      dispatch(
        requestCompletenessStatusForFinSobSidePanelItem({
          partnerId,
          programType: buttonCurrType,
          fYear: fyear,
          category: currentCat,
        })
      )

      if (partnerInfo?.OfficeHWPlanNdpUsd && props?.onReloadPartnerInfo) {
        props.onReloadPartnerInfo()
      }
    } catch (error) {
      Logger.error(error)

      if (isPlanningSaved) {
        NotificationController.showWarning({
          message:
            'Planning data was saved, but post-save updates failed. Please refresh the page later.',
        })
      } else {
        NotificationController.showError({
          message: 'Planning data was not saved. Please try again.',
        })
      }
    } finally {
      setIsChangeApplying(false)
      dispatch(changeFinSobIsCategoryPlanningApplyingChangesLoading(false))

      if (isPlanningSaved) {
        props.onSaveSuccess?.()
      }
    }
  }

  /**
   * Obsolete, use getFinSobValue
   */
  const getValue = (
    settingsIndex: number,
    type: 'actuals' | 'targets' | 'quota',
    fy: number,
    fq: number,
    isUnits: boolean,
    sType: TSType,
    isSoB: boolean,
    isNoSplit: boolean,
    isRollUp: boolean,
    fieldName?: string
  ): number => {
    let items = !isNoSplit ? targetsItems : targetsNoSplitItems

    if (type === 'actuals') {
      items = !isNoSplit ? actualsItems : actualsNoSplitItems
    }
    if (type === 'quota') {
      items = quotaItems
    }
    if (isRollUp) {
      if (type === 'actuals') {
        items = actualsRollupItems
      } else {
        items = targetsRollupItems
      }
    }

    if (settingsIndex < props.formats.length) {
      const setting = props.formats[settingsIndex]
      const isDirect = false

      return getPlanValue(
        setting,
        items,
        partnerId,
        fy,
        fq,
        currentValueType,
        isUnits,
        currency,
        isFixedCollapsed,
        sType,
        isSoB,
        isDirect,
        isShowOnlyCompletedPlans,
        isShowComposedSoB,
        isRecalcPlans,
        props.composedReportMode,
        props.isQuarterlyBusinessReviewMode,
        fieldName
      )
    } else {
      return 0
    }
  }

  const getFinSobProps = (): ICheckFinSobValues => {
    const finSobProps: ICheckFinSobValues = {
      programType: buttonCurrType,
      category: currentCat,

      targetsItems,
      targetsNoSplitItems,
      actualsItems,
      actualsNoSplitItems,
      quotaItems,
      targetsRollupItems: targetsRollupItems,
      actualsRollupItems: actualsRollupItems,
      actualsPartnerCountItems,

      formats: props.formats,
      partnerId,
      actualsType: currentValueType,
      currency,
      isCollapsed, // Or use isFixedCollapsed?
      isShowOnlyCompletedPlans,
      isShowComposedSoB,
      isRecalcPlans,
      isComposedReportMode: props.composedReportMode,
      isQuarterlyBusinessReviewMode: props.isQuarterlyBusinessReviewMode,
      currentFQuarter: jbpSettings.currentFQuarter,

      settingsIndex: 0,
      type: 'targets',
      fy: fyear,
      fq: 0,
      isUnits: false,
      sType: '',
      isSoB: false,
      isNoSplit: false,
      isRollUp: false,
      isDirect: false,
      fieldName: '',
      partnerFlags: getPartnerFlags(partnerInfo),
      isUseContractuals,
      isDistributorPlanner: props.isDistributorPlanner,
    }

    return finSobProps
  }

  const getFinSobValueProps = (idx: number, fq: number): IGetFinSobValueProps => {
    const isUnits = false
    const isSoB = false
    const sTotal = ''
    const isNoSplit = false
    const isRollUp = false
    const isDirect = false

    const finSobValueProps: IGetFinSobValueProps = {
      targetsItems,
      targetsNoSplitItems,
      actualsItems,
      actualsNoSplitItems,
      quotaItems,
      targetsRollupItems: targetsRollupItems,
      actualsRollupItems: actualsRollupItems,
      actualsPartnerCountItems,

      formats: props.formats,
      partnerId,
      actualsType: currentValueType,
      currency,
      isCollapsed,
      isShowOnlyCompletedPlans,
      isShowComposedSoB,
      isRecalcPlans,
      isComposedReportMode: props.composedReportMode,
      isQuarterlyBusinessReviewMode: props.isQuarterlyBusinessReviewMode,

      settingsIndex: idx,
      type: 'targets',
      fy: fyear,
      fq: fq,
      isUnits,
      sType: sTotal,
      isSoB,
      isNoSplit,
      isRollUp,
      isDirect,

      fieldName: '',
    }

    return finSobValueProps
  }

  const checkPolyPlanningLevel = () => {
    let checkPolyPlanningLevelType = ''

    let polyPlanningLevel = ''
    const polyPlanningLevelItem = props.additionalInfo?.find(
      (el) => el[AdditionalInfoKeys.PolyPlanningLevel]
    )
    if (polyPlanningLevelItem) {
      polyPlanningLevel = polyPlanningLevelItem[AdditionalInfoKeys.PolyPlanningLevel]
    }

    if (
      !!partnerInfo?.IsGlobal &&
      !!props.globalCategory?.GlobalCategory &&
      !!props.additionalInfo?.length &&
      ((props.globalCategory?.GlobalCategory === POLY_CATEGORY &&
        polyPlanningLevel !== 'Category') ||
        (POLY_SUB_CATEGORIES.indexOf(props.globalCategory?.GlobalCategory) >= 0 &&
          polyPlanningLevel !== 'SubCategory'))
    ) {
      checkPolyPlanningLevelType = polyPlanningLevel
    }

    return checkPolyPlanningLevelType
  }

  const setCustomField = (
    settingsIndex: number,
    value: string | null,
    fy: number,
    fq: number,
    customField: string,
    valueType: 'actuals' | 'targets' | 'quota'
  ): IJBPPlanningItem[] | null => {
    if (settingsIndex < props.formats.length) {
      const setting = props.formats[settingsIndex]

      const isIgnorePartnerId = !!props.composedReportMode || !!props.isQuarterlyBusinessReviewMode

      const isActuals = valueType === 'actuals'
      const isSob = customField === CustomFields.JustifySob
      const items = isActuals ? actualsItems : targetsItems

      // Items filtered on Top level by: PartnerId, IsActuals, IsTarget, IsQuota
      const sourceData = items.filter(
        (el) =>
          (el.PartnerId === partnerId || isIgnorePartnerId) &&
          el.ProgramTypes === setting.ProgramType &&
          el.Category === setting.Category &&
          el.SubCategory === setting.SubCategory &&
          el.L3Category === setting.L3Category &&
          el.FYear === fy &&
          el.FQuarter === fq
      )

      if (sourceData.length >= 1) {
        // Comment is not changing SoB
        const newItem = isSob
          ? { ...sourceData[0], [customField]: value, IsChangedSoB: 1 }
          : { ...sourceData[0], [customField]: value, IsChanged: 1 }
        const data = [...items]
        const idx = items.indexOf(sourceData[0])
        data.splice(idx, 1, newItem)

        isActuals ? setActualsItems([...data]) : setTargetsItems([...data])

        return [...data]
      } else {
        // error in data
      }
    }

    return null
  }

  const setIsL3CollapsedInternal = useCallback(
    (
      items: IJBPPlanningItem[],
      sIdx: number,
      newValue: boolean,
      fy: number
    ): { isUpdated: boolean; updatedItems: IJBPPlanningItem[] } => {
      if (sIdx < props.formats.length) {
        const setting = props.formats[sIdx]

        const isIgnorePartnerId =
          !!props.composedReportMode || !!props.isQuarterlyBusinessReviewMode

        // Items filtered on Top level by: PartnerId, IsActuals, IsTarget, IsQuota
        const sourceData = items.filter(
          (el) =>
            (el.PartnerId === partnerId || isIgnorePartnerId) &&
            el.ProgramTypes === setting.ProgramType &&
            el.Category === setting.Category &&
            el.SubCategory === setting.SubCategory &&
            el.L3Category === setting.L3Category &&
            el.FYear === fy
          //el.FQuarter === fq // All quarters
        )

        if (sourceData.length >= 1) {
          const data = [...items]

          sourceData.forEach((currItem) => {
            const newItem = {
              ...currItem,
              IsCollapsed: newValue ? 1 : 0,
              IsNoPlan: newValue ? currItem.IsNoPlan : 0,
              // IsCollapsed not changing SoB
              IsChanged: 1,
            }
            const idx = items.indexOf(currItem)
            data.splice(idx, 1, newItem)
          })

          return { isUpdated: true, updatedItems: [...data] }
        } else {
          // error in data
        }
      }

      return { isUpdated: false, updatedItems: items }
    },
    [props.formats, props.composedReportMode, props.isQuarterlyBusinessReviewMode, partnerId]
  )

  const setIsL3Collapsed = useCallback(
    (sIdx: number, newValue: boolean, fy: number) => {
      if (!props.composedReportMode) {
        const { isUpdated, updatedItems } = setIsL3CollapsedInternal(
          targetsItems,
          sIdx,
          newValue,
          fy
        )
        if (isUpdated) {
          setTargetsItems(updatedItems)
        }
      } else {
        // For right re-calculation in composedReportMode

        const { isUpdated: isUpdTarCurFY, updatedItems: updTarCurFY } = setIsL3CollapsedInternal(
          targetsItems,
          sIdx,
          newValue,
          fy
        )
        const { isUpdated: isUpdTarPreFY, updatedItems: updTargets } = setIsL3CollapsedInternal(
          updTarCurFY,
          sIdx,
          newValue,
          fy - 1
        )
        if (isUpdTarCurFY || isUpdTarPreFY) {
          setTargetsItems(updTargets)
        }

        const { isUpdated: isUpdActCurFY, updatedItems: updActCurFY } = setIsL3CollapsedInternal(
          actualsItems,
          sIdx,
          newValue,
          fy
        )
        const { isUpdated: isUpdActPreFY, updatedItems: updActuals } = setIsL3CollapsedInternal(
          updActCurFY,
          sIdx,
          newValue,
          fy - 1
        )
        if (isUpdActCurFY || isUpdActPreFY) {
          setActualsItems(updActuals)
        }
      }
    },
    [props.composedReportMode, setIsL3CollapsedInternal, targetsItems, actualsItems]
  )

  const setFinSob = (props: ISetFinSobParams): IJBPPlanningItem[] => {
    return setValue(
      props.settingsIndex,
      props.value,
      props.type,
      props.fy,
      props.fq,
      props.isUnits,
      props.isOverall,
      props.sType,
      props.isSoB,
      props.isNoSplit,
      props.itemsForUpdate,
      props.isCleanChild,
      props.sTypeOriginal,
      props.isNotManual
    )
  }

  const setValue = (
    settingsIndex: number,
    value: string | null,
    type: 'actuals' | 'targets' | 'quota',
    fy: number,
    fq: number,
    isUnits: boolean,
    isOverall: boolean,
    sType: TSType,
    isSoB: boolean,
    isNoSplit: boolean,
    itemsForUpdate?: IJBPPlanningItem[],
    isCleanChild?: boolean,
    sTypeOriginal?: TSType,
    isNotManual?: boolean
  ): IJBPPlanningItem[] => {
    let items = !isNoSplit ? targetsItems : targetsNoSplitItems
    let reserv = reservedTargets
    if (itemsForUpdate && itemsForUpdate.length && type === 'targets') {
      items = itemsForUpdate
    } else {
      if (type === 'actuals') {
        items = !isNoSplit ? actualsItems : actualsNoSplitItems
        reserv = reservedActuals
      }
      if (type === 'quota') {
        items = quotaItems
      }
    }
    let data = [...items]

    if (settingsIndex < props.formats.length) {
      const setting = props.formats[settingsIndex]

      const cat = setting.Category
      const l3Cat = setting.L3Category
      const isL3Overall = l3Cat === OVERALL_CATEGORY
      const isL3 = !!l3Cat
      const isL3DetailRow = isL3 && !isL3Overall

      const fieldProps = {
        actualsType: currentValueType,
        isUnits,
        currency,
        sType,
        isSoB,
        isDirect: false,
      }

      const isIgnorePartnerId = !!props.composedReportMode || !!props.isQuarterlyBusinessReviewMode

      // Items filtered on Top level by: PartnerId, IsActuals, IsTarget, IsQuota
      const sourceData = items.filter(
        (el) =>
          (el.PartnerId === partnerId || isIgnorePartnerId) &&
          el.ProgramTypes === setting.ProgramType &&
          el.Category === setting.Category &&
          el.SubCategory === setting.SubCategory &&
          el.L3Category === setting.L3Category &&
          el.FYear === fy &&
          el.FQuarter === fq
      )
      if (sourceData.length >= 1) {
        const newItem = setItemValuesUniversal(
          sourceData[0],
          value,
          fieldProps,
          cat,
          !isNotManual,
          props.translationFactors,
          sTypeOriginal
        )

        const idx = items.indexOf(sourceData[0])
        data.splice(idx, 1, newItem)

        if (type === 'actuals') {
          setActualsItems([...data])
        } else {
          setTargetsItems([...data])
        }

        if (!isSoB) {
          const isPlanningByFY = fq >= PLANNING_BY_FY_FQ
          //if (!isYearlyPlanning) {
          if (isPlanningByFY) {
            data = setQuarterByFYTotal({
              items: data,
              reservedItems: reserv,
              setting,
              fieldProps,
              fy,
              type,
              setTargetsItems,
              setActualsItems,
              translationFactors: props.translationFactors,
            })
          } else {
            data = setFYTotalByQuarters({
              items: data,
              setting,
              fieldProps,
              fy,
              setTargetsItems,
              translationFactors: props.translationFactors,
            })
          }
          //}

          const isL3DetailRow = isL3 && !isL3Overall

          if (!isOverall || isL3DetailRow) {
            if (isL3DetailRow) {
              // Recalc L3 Category Overall
              data = setOverallTotal(data, setting, fieldProps, fy, fq, isL3DetailRow)

              // Recalc Overall row FY by Q or Q by FY
              const overallSettingsL3 = props.formats.filter(
                (el) =>
                  el.ProgramType === setting.ProgramType &&
                  el.Category === setting.Category &&
                  el.SubCategory === setting.SubCategory
              )

              if (overallSettingsL3.length) {
                const overallSet = overallSettingsL3[0]

                if (isPlanningByFY) {
                  data = setQuarterByFYTotal({
                    items: data,
                    reservedItems: reserv,
                    setting: overallSet,
                    fieldProps,
                    fy,
                    type,
                    setTargetsItems,
                    setActualsItems,
                    translationFactors: props.translationFactors,
                  })
                } else {
                  data = setFYTotalByQuarters({
                    items: data,
                    setting: overallSet,
                    fieldProps,
                    fy,
                    setTargetsItems,
                    translationFactors: props.translationFactors,
                  })
                }
              }
            }

            // Recalc Category Overall
            // TODO: Find Category Overall if currently edit L3 Overall
            data = setOverallTotal(data, setting, fieldProps, fy, fq, false)

            // Recalc Overall row Fy by Q or Q by FY
            const overallSettings = props.formats.filter(
              (el) =>
                el.ProgramType === setting.ProgramType &&
                el.Category === setting.Category &&
                (!el.SubCategory || el.SubCategory === OVERALL_CATEGORY)
            )

            if (overallSettings.length) {
              const overallSet = overallSettings[0]

              if (isPlanningByFY) {
                data = setQuarterByFYTotal({
                  items: data,
                  reservedItems: reserv,
                  setting: overallSet,
                  fieldProps,
                  fy,
                  type,
                  setTargetsItems,
                  setActualsItems,
                  translationFactors: props.translationFactors,
                })
              } else {
                data = setFYTotalByQuarters({
                  items: data,
                  setting: overallSet,
                  fieldProps,
                  fy,
                  setTargetsItems,
                  translationFactors: props.translationFactors,
                })
              }
            }
          }

          if (isOverall && !!sType && !!isCleanChild) {
            data = cleanQuartersAndFY({
              items: data,
              setting,
              fieldProps,
              fy,
              setTargetsItems,
              translationFactors: props.translationFactors,
            })
          }
        }

        // FY23 SoB algoritm
        if (
          isSoB &&
          !isSoBNewLogic &&
          fq >= PLANNING_BY_FY_FQ &&
          fy === fyear - 1 &&
          type === 'actuals'
        ) {
          data = setQuarterByFYTotal({
            items: data,
            reservedItems: reserv,
            setting,
            fieldProps,
            fy,
            type,
            setTargetsItems,
            setActualsItems,
            translationFactors: props.translationFactors,
          })
        }

        // FY25 SoB algoritm: Recalc SoB for Category Overall based on all SubCategories
        if (!isUnits && IS_RECALC_SOB && (type === 'actuals' || type === 'targets') && !isOverall) {
          data = calcSoBCategoryOverallForCategory({
            items: data,
            categorySettings: props.formats,
            fieldProps: { ...fieldProps, isSoB: true },
            programType: setting.ProgramType,
            category: setting.Category,
            fyear,
            fy,
            fq,
            type,
            setActualsItems,
            setTargetsItems,
            currentFYear: jbpSettings.currentFYear,
            currentFQuarter: jbpSettings.currentFQuarter,
            translationFactors: props.translationFactors,
            isYearlyPlanning,
          })
        }

        // FY24 SoB algoritm: 1. recalc FYear SoB if Quarters SoB changed
        if (
          isSoB &&
          isSoBNewLogic &&
          fq !== PLANNING_BY_FY_FQ &&
          (fy === fyear || fy === fyear - 1) &&
          (type === 'actuals' || type === 'targets')
        ) {
          data = setFySobByQuarters(
            data,
            setting,
            fieldProps,
            fy,
            type,
            setActualsItems,
            setTargetsItems,
            jbpSettings.currentFYear,
            jbpSettings.currentFQuarter,
            props.translationFactors
          )
        }
        // FY24 SoB algoritm: 2. recalc FYear SoB if Quarters Plan changed
        if (
          !isSoB &&
          isSoBNewLogic &&
          fq !== PLANNING_BY_FY_FQ &&
          fy === fyear &&
          type === 'targets'
        ) {
          const sobFieldProps = { ...fieldProps, isSoB: true }

          // 2.1 Recalc current row Fy by Q or Q by FY
          if (setting.IsSoBAvailable) {
            data = setFySobByQuarters(
              data,
              setting,
              sobFieldProps,
              fy,
              type,
              setActualsItems,
              setTargetsItems,
              jbpSettings.currentFYear,
              jbpSettings.currentFQuarter,
              props.translationFactors
            )
          }

          if (isL3DetailRow) {
            // 2.3 Recalc L3 Overall row Fy by Q or Q by FY
            const overallSettings = props.formats.filter(
              (el) =>
                el.ProgramType === setting.ProgramType &&
                el.Category === setting.Category &&
                el.SubCategory === setting.SubCategory &&
                el.L3Category === OVERALL_CATEGORY
            )

            if (overallSettings.length) {
              const overallSet = overallSettings[0]
              data = setFySobByQuarters(
                data,
                overallSet,
                sobFieldProps,
                fy,
                type,
                setActualsItems,
                setTargetsItems,
                jbpSettings.currentFYear,
                jbpSettings.currentFQuarter,
                props.translationFactors
              )
            }
          }

          // 2.3 Recalc Category Overall row Fy by Q or Q by FY
          const overallSettings = props.formats.filter(
            (el) =>
              el.ProgramType === setting.ProgramType &&
              el.Category === setting.Category &&
              (!el.SubCategory || el.SubCategory === OVERALL_CATEGORY)
          )

          if (overallSettings.length) {
            const overallSet = overallSettings[0]
            data = setFySobByQuarters(
              data,
              overallSet,
              sobFieldProps,
              fy,
              type,
              setActualsItems,
              setTargetsItems,
              jbpSettings.currentFYear,
              jbpSettings.currentFQuarter,
              props.translationFactors
            )
          }
        }

        //updatePendingData(data)
      } else {
        // error in data
      }
    }

    return data
  }

  const setOverallTotal = (
    items: IJBPPlanningItem[],
    setting: IFormActualsTargetsSettings,
    fieldProps: IFieldProps,
    fy: number,
    fq: number,
    isL3DetailRow: boolean
  ) => {
    const data = [...items]

    const fieldName = getFieldName(fieldProps)
    const cat = setting.Category

    const subCategoryForOverall = isL3DetailRow ? setting.SubCategory : OVERALL_CATEGORY

    const isIgnorePartnerId = !!props.composedReportMode || !!props.isQuarterlyBusinessReviewMode

    const overallCatData = items.filter(
      (el) =>
        (el.PartnerId === partnerId || isIgnorePartnerId) &&
        el.ProgramTypes === setting.ProgramType &&
        el.Category === setting.Category &&
        // Only Category overall
        el.SubCategory === subCategoryForOverall &&
        (!isL3DetailRow || el.L3Category === OVERALL_CATEGORY) &&
        el.FYear === fy &&
        el.FQuarter === fq
    )

    if (overallCatData.length >= 1) {
      // Calc Total
      const subCategoryData = items.filter(
        (el) =>
          (el.PartnerId === partnerId || isIgnorePartnerId) &&
          el.ProgramTypes === setting.ProgramType &&
          el.Category === setting.Category &&
          // Only Sub-categories
          ((!isL3DetailRow && el.SubCategory !== OVERALL_CATEGORY) ||
            (isL3DetailRow && el.SubCategory === setting.SubCategory)) &&
          ((!isL3DetailRow && (!el.L3Category || el.L3Category === OVERALL_CATEGORY)) ||
            (isL3DetailRow && el.L3Category !== OVERALL_CATEGORY)) &&
          el.FYear === fy &&
          el.FQuarter === fq
      )

      let total: number | null = null
      subCategoryData.forEach((el) => {
        const val = el[fieldName]
        if (val || val === 0) {
          total = (total ?? 0) + Number(val || 0)
        }
      })

      // Set Total
      const newItem = setItemValuesUniversal(
        overallCatData[0],
        total,
        fieldProps,
        cat,
        false,
        props.translationFactors
      )

      const idx = items.indexOf(overallCatData[0])
      data.splice(idx, 1, newItem)

      setTargetsItems([...data])
    }

    return data
  }

  const isTransactionalValid = () => {
    let isValid = true

    const isUnits = false
    const isSoB = false

    if (isUseContractuals && !isCategoryNA && isShowCurrencyBlock) {
      props.formats.forEach((format, idx) => {
        const subCat = format.SubCategory
        const isOverall = subCat === OVERALL_CATEGORY || !subCat

        if (!isFixedCollapsed || isOverall) {
          for (let q = 1; q <= 5; q++) {
            const currTargetsTotal = getValue(
              idx,
              'targets',
              fyear,
              q,
              isUnits,
              '',
              isSoB,
              false,
              false
            ) // Total
            const currTargetsContr = getValue(
              idx,
              'targets',
              fyear,
              q,
              isUnits,
              'c',
              isSoB,
              false,
              false
            ) // Contractual
            const currTargetsTran = Number(currTargetsTotal || 0) - Number(currTargetsContr || 0)

            if (currTargetsTran < 0) {
              isValid = false
            }
          }
        }
      })
    }

    return isValid
  }

  const calcCollapseMode = useCallback(() => {
    if (partnerInfo) {
      // Set IsCollapsed for Currency planning
      const flags = props.partnerFlagsState
      const cat = currentCat
      const formats = props.formats
      const isFlagsEnabledInSubCat = isPartnerFlagActive(flags, formats, cat)
      const isFlagsEnabledForUnits = isPartnerFlagActive(flags, formats, cat, true, true)
      // Retail Collapse: !isRetailer &&
      const isCollapseAllowedSetting =
        !isRetailer &&
        props.dataSetInfo.MandatoryType !== MANDATORY_CATEGORY_ALWAYS_EXPANDED &&
        !isFlagsEnabledInSubCat

      setIsCollapseAllowed(isCollapseAllowedSetting)
      setIsCollapsed((val) => val && isCollapseAllowedSetting && !isFlagsEnabledInSubCat)

      // Set IsCollapsed for Units planning
      if (isFlagsEnabledForUnits && !isOn(currentCat, 'units')) {
        setSetting(currentCat, 'units')
      }
      setIsUnitsMandatory(isFlagsEnabledForUnits)
    }
  }, [partnerInfo, props.dataSetInfo.MandatoryType, props.partnerFlagsState])

  const getInputElementId = useCallback((p: Partial<IFinSobValidationError>) => {
    const finSob = p.isSob ? 'sob' : 'fin'
    const units = p.isUnits ? '-units' : ''

    return `${p.categoryKey}-${p.settingIndex}-${p.valueType}-${p.year}-${p.q}-${finSob}${units}`
      .replace(/\s/g, '')
      .toLowerCase()
  }, [])

  /** -------------------- User actions handlers ----------------------- */

  const onChangeNotApplicable = async () => {
    dispatch(changeFinSobIsCategoryPlanningDataLoading(true))
    const isNotApplicable = isCategoryNA ? 0 : 1
    await changeNotApplicableHndl({
      isNotApplicable,
      categoryField: currentCat,
    })

    dispatch(changeFinSobIsCategoryPlanningDataLoading(false))
  }

  const confirmNotApplicable = async () => {
    setIsShowConfirmNotApplicableDialog(false)
    await onChangeNotApplicable()
  }

  const cancelNotApplicable = () => {
    setIsShowConfirmNotApplicableDialog(false)
  }

  const setSetting = async (key: string, type: TSettingsSuffix) => {
    dispatch(changeFinSobIsCategoryPlanningApplyingChangesLoading(true))

    const isQuarter = type === 'quarter'
    const defaultValue = isQuarter ? isQuarterDefaultOn : false
    const currentValue = isOn(key, type, defaultValue)
    const newValue = currentValue ? 0 : 1
    const field = getNAField(key, type)
    const settingForUpdate = createSectionSettingsPatch({
      [field]: newValue,
    })

    await dispatch(
      updateSectionSettings({
        sectionSettings: settingForUpdate,
        controlName: 'Planning',
        flag: field,
        state: newValue,
      })
    ).unwrap()

    // Not appropriated for 'quarter' | 'sob' | 'units' switchers
    //await dropSignature('Financial & SOB Targets')

    dispatch(changeFinSobIsCategoryPlanningApplyingChangesLoading(false))
  }

  const discardChanges = () => {
    setTargetsItems([
      ...reservedTargets.map((el) => {
        return { ...el, IsChanged: 0, IsChangedSoB: 0 }
      }),
    ])
    setActualsItems([
      ...reservedActuals.map((el) => {
        return { ...el, IsChanged: 0, IsChangedSoB: 0 }
      }),
    ])
    const isCollapsedCategory = getIsCollapsedCategory(reservedTargets, fyear)
    setIsCollapsed(isCollapsedCategory && isCollapseAllowed)
  }

  const applyChangesHandler = async () => {
    const newPolyPlanningLevel = checkPolyPlanningLevel()
    const finSobProps = getFinSobProps()
    const finSobValidationResult =
      !isRetailer && isFinSobPlanQuarterlyChecksEnabled ? checkFinSobValues(finSobProps) : []
    const isSignatureWillBeDropped =
      isNeedToShowSignDialog && !isOverallValueNotChanged(partnerInfo)

    if (newPolyPlanningLevel) {
      setPolyPlanningLevel(newPolyPlanningLevel)
    } else if (finSobValidationResult.length > 0) {
      // Find first unconfirmed Input index
      const unconfirmedInputIndexes = Array.from(
        new Set(finSobValidationResult.map((el) => el.inputIndex))
      ).sort((a, b) => a - b)
      const newInputIndex = unconfirmedInputIndexes[0]

      setValidationErrors(finSobValidationResult)
      setValidationInputIndex(newInputIndex)
      switchSplitType(newInputIndex, finSobValidationResult)

      props.setIsShowValidationPopup(true)
    } else if (!checkFinSobRate(finSobProps)) {
      setIsShowRateDialog(true)
    } else if (isSignatureWillBeDropped) {
      setIsShowSignDialog(true)
    } else if (isSwitchersChanged) {
      setIsShowConfirmSwitchersChangeDialog(true)
    } else {
      await applyChanges(targetsItems)
    }
  }

  const switchSplitType = useCallback(
    (newValidationInputIndex: number, newValidationErrors: IFinSobValidationError[]) => {
      const validationErrorsInput = newValidationErrors.filter(
        (el) => el.inputIndex === newValidationInputIndex
      )
      if (validationErrorsInput.length) {
        const validationError = validationErrorsInput[0]

        if (isUseContractuals) {
          if (validationError.isSob && splitType !== 'Total') {
            setSplitType('Total')
          } else if (!validationError.isSob) {
            switch (validationError.sType) {
              case 'c':
                if (splitType !== 'Contractual') {
                  setSplitType('Contractual')
                }
                break
              case 't':
                if (splitType !== 'Transactional') {
                  setSplitType('Transactional')
                }
                break
              default:
                if (splitType !== 'Total') {
                  setSplitType('Total')
                }
                break
            }
          }
        }

        // Scroll to Input element
        const inputElementId = getInputElementId(validationError)
        const inputElement = document.getElementById(inputElementId)
        if (inputElement) {
          scrollElementIntoPage(inputElement, { offset: 150, behavior: 'smooth' })
        }
      }
    },
    [getInputElementId, isUseContractuals, splitType]
  )

  /** -------------------- Render methods ----------------------- */

  const findParentCategoryIndex = (settingsIndex: number) => {
    let idx = settingsIndex

    if (settingsIndex < props.formats.length) {
      const setting = props.formats[settingsIndex]

      //const cat = setting.Category
      const subCat = setting.SubCategory
      const l3Cat = setting.L3Category
      const isL3Overall = l3Cat === OVERALL_CATEGORY
      const isL3 = !!l3Cat
      const isL3DetailRow = isL3 && !isL3Overall
      const isOverall = subCat === OVERALL_CATEGORY || !subCat

      if (!isOverall || isL3DetailRow) {
        if (isL3DetailRow) {
          const overallSettingsL3 = props.formats.filter(
            (el) =>
              el.ProgramType === setting.ProgramType &&
              el.Category === setting.Category &&
              el.SubCategory === setting.SubCategory
          )

          if (overallSettingsL3.length) {
            const overallSet = overallSettingsL3[0]
            idx = props.formats.indexOf(overallSet)
          }
        }
      }
    }

    return idx
  }

  const getCountInLevel = (settingsIndex: number) => {
    let idx = 1

    if (settingsIndex < props.formats.length) {
      const setting = props.formats[settingsIndex]

      //const cat = setting.Category
      const subCat = setting.SubCategory
      const l3Cat = setting.L3Category
      const isL3Overall = l3Cat === OVERALL_CATEGORY
      const isL3 = !!l3Cat
      const isL3DetailRow = isL3 && !isL3Overall
      const isOverall = subCat === OVERALL_CATEGORY || !subCat

      if (!isOverall || isL3DetailRow) {
        if (isL3DetailRow) {
          const overallSettingsL3 = props.formats.filter(
            (el) =>
              el.ProgramType === setting.ProgramType &&
              el.Category === setting.Category &&
              el.SubCategory === setting.SubCategory &&
              el.L3Category !== OVERALL_CATEGORY
          )

          if (overallSettingsL3.length) {
            idx = overallSettingsL3.length
          }
        }
      }
    }

    return idx
  }

  const checkIsFirstInLevel = (settingsIndex: number) => {
    let idx = false

    if (settingsIndex < props.formats.length) {
      const setting = props.formats[settingsIndex]

      //const cat = setting.Category
      const subCat = setting.SubCategory
      const l3Cat = setting.L3Category
      const isL3Overall = l3Cat === OVERALL_CATEGORY
      const isL3 = !!l3Cat
      const isL3DetailRow = isL3 && !isL3Overall
      const isOverall = subCat === OVERALL_CATEGORY || !subCat

      if (!isOverall || isL3DetailRow) {
        if (isL3DetailRow) {
          const overallSettingsL3 = props.formats.filter(
            (el) =>
              el.ProgramType === setting.ProgramType &&
              el.Category === setting.Category &&
              el.SubCategory === setting.SubCategory &&
              el.L3Category !== OVERALL_CATEGORY
          )

          if (overallSettingsL3.length) {
            const setting1 = overallSettingsL3[0]
            const idx1 = props.formats.indexOf(setting1)
            idx = idx1 === settingsIndex
          }
        }
      }
    }

    return idx
  }

  const renderOverall = (idx: number, isOverall: boolean, isL3Overall: boolean) => {
    const fq = PLANNING_BY_FY_FQ
    const finProps = getFinSobValueProps(idx, fq)
    const sobProps: IGetFinSobValueProps = {
      ...finProps,
      isSoB: true,
    }

    const pyAct = getFinSobValue({ ...finProps, type: 'actuals', fy: fyear - 1 })
    const cyGoal = getFinSobValue({ ...finProps, type: 'targets' })
    const cyAct = getFinSobValue({ ...finProps, type: 'actuals' })
    const pySobAct = getFinSobValue({ ...sobProps, type: 'actuals', fy: fyear - 1 })
    const cySobGoal = getFinSobValue({ ...sobProps, type: 'targets' })
    const cySobAct = getFinSobValue({ ...sobProps, type: 'actuals' })

    const rounding = finProps.isUnits ? '' : props.rounding || props.roundingValue
    const isRounding = rounding && rounding !== PlanningRounding.AsIs
    const finFractionDigits = isRounding ? FIN_FRACTION_DIGITS_ROUNDING : 0

    // const pyActRound = getRoundedValue(pyAct, rounding)
    // const cyGoalRound = getRoundedValue(cyGoal, rounding)

    const yoyGoal = calcPercentage(pyAct, cyGoal)
    const yoyActuals = calcPercentage(pyAct, cyAct)
    const yoySobGoal = calcDiff(pySobAct, cySobGoal)
    const yoySobActuals = calcDiff(pySobAct, cySobAct)

    // const isL3 = false
    const isSubCatCell = !isOverall && isL3Overall
    const cellClassName = cn(
      { [styles.subCatCell]: isSubCatCell },
      { [styles.overallCell]: isOverall }
    )

    const pyTam = pyAct / pySobAct
    const cyTam = cyGoal / cySobGoal
    const tam = calcPercentage(pyTam, cyTam)

    return (
      <>
        <td className={cellClassName}>
          <GrowField percent={tam} fractionDigits={SOB_FRACTION_DIGITS} />
        </td>
        <td className={cellClassName}>
          <ViewField
            fieldValue={pyAct}
            fieldType={'actuals'}
            fractionDigits={finFractionDigits}
            rounding={rounding}
          />
        </td>
        <td className={cellClassName}>
          <ViewField
            fieldValue={cyGoal}
            fieldType={'targets'}
            fractionDigits={finFractionDigits}
            rounding={rounding}
          />
        </td>
        <td className={cellClassName}>
          <GrowField percent={yoyGoal} fractionDigits={SOB_FRACTION_DIGITS} />
        </td>
        {IS_SHOW_CY_ACTUALS_COLUMNS && (
          <>
            <td className={cellClassName}>
              <ViewField
                fieldValue={cyAct}
                fieldType={'actuals'}
                fractionDigits={finFractionDigits}
                rounding={rounding}
              />
            </td>
            <td className={cellClassName}>
              <GrowField percent={yoyActuals} fractionDigits={SOB_FRACTION_DIGITS} />
            </td>
          </>
        )}
        <td className={cellClassName}>
          <ViewField
            fieldValue={pySobAct}
            fieldType={'actuals'}
            fractionDigits={SOB_FRACTION_DIGITS}
            percent
          />
        </td>
        <td className={cellClassName}>
          <ViewField
            fieldValue={cySobGoal}
            fieldType={'targets'}
            fractionDigits={SOB_FRACTION_DIGITS}
            percent
          />
        </td>
        <td className={cellClassName}>
          <GrowField percent={yoySobGoal} fractionDigits={SOB_FRACTION_DIGITS} diff />
        </td>
        {IS_SHOW_CY_ACTUALS_COLUMNS && (
          <>
            <td className={cellClassName}>
              <ViewField
                fieldValue={cySobAct}
                fieldType={'actuals'}
                fractionDigits={SOB_FRACTION_DIGITS}
                percent
              />
            </td>
            <td className={cellClassName}>
              <GrowField percent={yoySobActuals} fractionDigits={SOB_FRACTION_DIGITS} diff />
            </td>
          </>
        )}
      </>
    )
  }

  const renderL3 = (idx: number, isOverall: boolean) => {
    const fq = PLANNING_BY_FY_FQ
    const isUnits = false
    const isSoB = false
    const sTotal = ''
    const isNoSplit = false
    //const isRollUp = false
    // mod: 'prevPrev' | 'prev' | 'calc' | 'curr' | 'futr'

    const finProps = getFinSobValueProps(idx, fq)
    const setFinProps: ISetFinSobParams = {
      settingsIndex: idx,
      value: null,
      type: 'targets',
      fy: fyear,
      fq: fq,
      isUnits,
      isOverall: isOverall,
      sType: sTotal,
      isSoB,
      isNoSplit,
    }

    const overallCategoryIdx = findParentCategoryIndex(idx)
    const finOvrProps: IGetFinSobValueProps = { ...finProps, settingsIndex: overallCategoryIdx }
    const sobOvrProps: IGetFinSobValueProps = {
      ...finProps,
      isSoB: true,
      settingsIndex: overallCategoryIdx,
    }
    const setSobOvrProps: ISetFinSobParams = {
      ...setFinProps,
      isSoB: true,
      settingsIndex: overallCategoryIdx,
    }

    const pyAct = getFinSobValue({ ...finProps, type: 'actuals', fy: fyear - 1 })
    const cyGoal = getFinSobValue({ ...finProps, type: 'targets' })
    const cyAct = getFinSobValue({ ...finProps, type: 'actuals' })
    const pyOvrAct = getFinSobValue({ ...finOvrProps, type: 'actuals', fy: fyear - 1 })
    const cyOvrGoal = getFinSobValue({ ...finOvrProps, type: 'targets' })
    const pySobOvrAct = getFinSobValue({ ...sobOvrProps, type: 'actuals', fy: fyear - 1 })
    const cySobOvrGoal = getFinSobValue({ ...sobOvrProps, type: 'targets' })
    const cySobOvrAct = getFinSobValue({ ...sobOvrProps, type: 'actuals' })

    const rounding = isUnits ? '' : props.rounding || props.roundingValue
    const isRounding = rounding && rounding !== PlanningRounding.AsIs
    const fractionDigits = isRounding ? FIN_FRACTION_DIGITS_ROUNDING : 0

    // const pyActRound = getRoundedValue(pyAct, rounding)
    const cyGoalRound = getRoundedValue(cyGoal, rounding)

    const yoyGoal = calcPercentage(pyAct, cyGoal)
    const yoyActuals = calcPercentage(pyAct, cyAct)
    const yoySobGoal = calcDiff(pySobOvrAct, cySobOvrGoal)
    const yoySobActuals = calcDiff(pySobOvrAct, cySobOvrAct)

    const flags = partnerInfo?.PartnerFlags || ''
    const isMandatoryFinByFlag = isSubCategoryMandatory(
      flags,
      props.formats[idx]?.MandatoryByFlags,
      sectionSettings,
      false
    )
    const isMandatorySobByFlag = isSubCategoryMandatory(
      flags,
      props.formats[idx]?.SOBMandatoryByFlags,
      sectionSettings,
      false
    )
    const isShowMandatoryFin = isMandatoryByFlagLogic
      ? isMandatoryFinByFlag.isMandatory
      : isOverall || !isCollapseAllowed
    const isShowMandatory = isShowMandatoryFin && !props.composedReportMode
    const isShowMandatorySob =
      (isMandatorySobByFlag.isMandatory || false) && !props.composedReportMode

    const isInputDisabled = false
    const isCellHighlighted = false
    const isShowInputPopup = false

    const rowsWithThisLevel = getCountInLevel(idx)
    const isFirstInLevel = checkIsFirstInLevel(idx)

    const pyTam = pyOvrAct / pySobOvrAct
    const cyTam = cyOvrGoal / cySobOvrGoal
    const tam = ((cyTam - pyTam) / pyTam) * 100

    return !isEditMode ? (
      <>
        {isFirstInLevel && (
          <td rowSpan={rowsWithThisLevel}>
            <GrowField percent={tam} fractionDigits={SOB_FRACTION_DIGITS} />
          </td>
        )}
        <td>
          <ViewField
            fieldValue={pyAct}
            fieldType={'actuals'}
            fractionDigits={fractionDigits}
            rounding={rounding}
          />
        </td>
        <td>
          <ViewField
            fieldValue={cyGoal}
            fieldType={'targets'}
            fractionDigits={fractionDigits}
            rounding={rounding}
          />
        </td>
        <td>
          <GrowField percent={yoyGoal} fractionDigits={SOB_FRACTION_DIGITS} />
        </td>
        {IS_SHOW_CY_ACTUALS_COLUMNS && (
          <>
            <td>
              <ViewField
                fieldValue={cyAct}
                fieldType={'actuals'}
                fractionDigits={fractionDigits}
                rounding={rounding}
              />
            </td>
            <td>
              <GrowField percent={yoyActuals} fractionDigits={SOB_FRACTION_DIGITS} />
            </td>
          </>
        )}
        {isFirstInLevel && (
          <td rowSpan={rowsWithThisLevel}>
            <ViewField
              fieldValue={pySobOvrAct}
              fieldType={'actuals'}
              fractionDigits={SOB_FRACTION_DIGITS}
              percent
            />
          </td>
        )}
        {isFirstInLevel && (
          <td rowSpan={rowsWithThisLevel}>
            <ViewField
              fieldValue={cySobOvrGoal}
              fieldType={'targets'}
              fractionDigits={SOB_FRACTION_DIGITS}
              percent
            />
          </td>
        )}
        {isFirstInLevel && (
          <td rowSpan={rowsWithThisLevel}>
            <GrowField percent={yoySobGoal} fractionDigits={SOB_FRACTION_DIGITS} diff />
          </td>
        )}
        {IS_SHOW_CY_ACTUALS_COLUMNS && isFirstInLevel && (
          <>
            <td rowSpan={rowsWithThisLevel}>
              <ViewField
                fieldValue={cySobOvrAct}
                fieldType={'actuals'}
                fractionDigits={SOB_FRACTION_DIGITS}
                percent
              />
            </td>
            <td rowSpan={rowsWithThisLevel}>
              <GrowField percent={yoySobActuals} fractionDigits={SOB_FRACTION_DIGITS} diff />
            </td>
          </>
        )}
      </>
    ) : (
      <>
        {isFirstInLevel && (
          <td rowSpan={rowsWithThisLevel}>
            <GrowField percent={tam} fractionDigits={SOB_FRACTION_DIGITS} />
          </td>
        )}
        <td>
          <ViewField
            fieldValue={pyAct}
            fieldType={'actuals'}
            fractionDigits={fractionDigits}
            rounding={rounding}
          />
        </td>
        <td>
          <MandatoryField value={cyGoal} isShow={isShowMandatory} />
          <NumberInput
            id={'inputElementId-2'}
            disabled={isInputDisabled || props.isShowValidationPopup}
            hasSpin={false}
            align="right"
            classes={{
              inputClasses: {
                root: cn(
                  styles.cell,
                  styles.cell__input,
                  { [styles.highlighted]: isCellHighlighted },
                  { [styles.validating]: isShowInputPopup }
                ),
                content: styles.numberInput,
              },
            }}
            value={cyGoalRound || cyGoalRound === 0 ? cyGoalRound.toString() : ''}
            onChange={(valueStr) => {
              const value = valueStr
                ? getRestoredValue(Number(valueStr || 0), rounding).toFixed(0)
                : null
              setFinSob({ ...setFinProps, value })
              if (!(overallCategoryIdx in l3CollapsedFlags)) {
                setL3CollapsedFlags((prev) => ({ ...prev, [overallCategoryIdx]: 1 }))
              }
            }}
            checkFn={ValidationHelper.checkNullableNumber}
            maximumFractionDigits={fractionDigits}
          />
        </td>
        <td>
          <GrowField percent={yoyGoal} fractionDigits={SOB_FRACTION_DIGITS} />
        </td>
        {IS_SHOW_CY_ACTUALS_COLUMNS && (
          <>
            <td>
              <ViewField
                fieldValue={cyAct}
                fieldType={'actuals'}
                fractionDigits={fractionDigits}
                rounding={rounding}
              />
            </td>
            <td>
              <GrowField percent={yoyActuals} fractionDigits={SOB_FRACTION_DIGITS} />
            </td>
          </>
        )}
        {isFirstInLevel && (
          <td rowSpan={rowsWithThisLevel} className={styles.editPercent}>
            <div className={styles.noWrapItem}>
              <MandatoryField value={pySobOvrAct} isShow={isShowMandatorySob} />
              <NumberInput
                id={'inputElementId-1'}
                disabled={isInputDisabled || props.isShowValidationPopup}
                hasSpin={false}
                align="right"
                classes={{
                  inputClasses: {
                    root: cn(
                      styles.cell,
                      styles.cell__input,
                      { [styles.highlighted]: isCellHighlighted },
                      { [styles.validating]: isShowInputPopup }
                    ),
                    content: styles.numberInput,
                  },
                }}
                value={pySobOvrAct || pySobOvrAct === 0 ? pySobOvrAct.toString() : ''}
                onChange={(value) => {
                  setFinSob({ ...setSobOvrProps, value, type: 'actuals', fy: fyear - 1 })
                  if (!(overallCategoryIdx in l3CollapsedFlags)) {
                    setL3CollapsedFlags((prev) => ({ ...prev, [overallCategoryIdx]: 1 }))
                  }
                }}
                checkFn={ValidationHelper.checkNullablePercent}
                maximumFractionDigits={SOB_FRACTION_DIGITS}
              />
              %
            </div>
          </td>
        )}
        {isFirstInLevel && (
          <td rowSpan={rowsWithThisLevel} className={styles.editPercent}>
            <div className={styles.noWrapItem}>
              <MandatoryField value={cySobOvrGoal} isShow={isShowMandatorySob} />
              <NumberInput
                id={'inputElementId-2'}
                disabled={isInputDisabled || props.isShowValidationPopup}
                hasSpin={false}
                align="right"
                classes={{
                  inputClasses: {
                    root: cn(
                      styles.cell,
                      styles.cell__input,
                      { [styles.highlighted]: isCellHighlighted },
                      { [styles.validating]: isShowInputPopup }
                    ),
                    content: styles.numberInput,
                  },
                }}
                value={cySobOvrGoal || cySobOvrGoal === 0 ? cySobOvrGoal.toString() : ''}
                onChange={(value) => {
                  setFinSob({ ...setSobOvrProps, value })
                  if (!(overallCategoryIdx in l3CollapsedFlags)) {
                    setL3CollapsedFlags((prev) => ({ ...prev, [overallCategoryIdx]: 1 }))
                  }
                }}
                checkFn={ValidationHelper.checkNullablePercent}
                maximumFractionDigits={SOB_FRACTION_DIGITS}
              />
              %
            </div>
          </td>
        )}
        {isFirstInLevel && (
          <td rowSpan={rowsWithThisLevel}>
            <GrowField percent={yoySobGoal} fractionDigits={SOB_FRACTION_DIGITS} diff />
          </td>
        )}
        {IS_SHOW_CY_ACTUALS_COLUMNS && isFirstInLevel && (
          <>
            <td rowSpan={rowsWithThisLevel}>
              <ViewField
                fieldValue={cySobOvrAct}
                fieldType={'actuals'}
                fractionDigits={SOB_FRACTION_DIGITS}
                percent
              />
            </td>
            <td rowSpan={rowsWithThisLevel}>
              <GrowField percent={yoySobActuals} fractionDigits={SOB_FRACTION_DIGITS} diff />
            </td>
          </>
        )}
      </>
    )
  }

  const renderApplySection = () => {
    const isApplyDisabled =
      !isDataChanged ||
      isNotChanged ||
      validationStatus !== ValidationStatus.Valid ||
      !isTransactionalValid()

    return (
      <table className={cn(stylesTable.table, stylesCompensation.table, styles.table)}>
        <caption className={styles.footer}>
          <div className={styles.buttonContent}>
            {isChangeApplying && <Loader className={styles.loader} />}
            <Button
              className={styles.footer__apply}
              disabled={isApplyDisabled}
              onClick={applyChangesHandler}
            >
              <Translation text={applyButtonKey} span />
            </Button>
          </div>
          <Button
            disabled={!isDataChanged || isNotChanged || validationStatus !== ValidationStatus.Valid}
            onClick={discardChanges}
            color={'grey'}
            className={styles.button}
          >
            <Translation text="jbp-cancel" span />
          </Button>
        </caption>
      </table>
    )
  }

  /** -------------------- Effects ----------------------- */

  useEffect(() => {
    if (!props.urlActualsValueType) return

    const urlTypeLower = props.urlActualsValueType.toLowerCase()
    const urlType = Object.values(ActualsValueTypes).find((v) => v.toLowerCase() === urlTypeLower)
    if (!urlType || !actualsTypes.includes(urlType)) return

    onChangeActualsType(urlType)
  }, [props.urlActualsValueType, actualsTypes, onChangeActualsType])

  useEffect(() => {
    if (partnerInfo) {
      calcCollapseMode()
    }
  }, [partnerInfo, calcCollapseMode])

  useEffect(() => {
    updatePendingData(undefined, ValidationStatus.Valid)

    if (
      (partnerId && fyear && buttonCurrType) ||
      props.composedReportMode ||
      props.isQuarterlyBusinessReviewMode
    ) {
      preparePlanningData()
    }
  }, [
    partnerId,
    fyear,
    buttonCurrType,
    props.composedReportMode,
    props.isQuarterlyBusinessReviewMode,
    preparePlanningData,
  ])

  useEffect(() => {
    if (!isCollapsed) {
      setIsShowComposedSoB(false)
    }
  }, [isCollapsed])

  useEffect(() => {
    const unconfirmedInputs = Array.from(
      new Set(validationErrors.filter((el) => !el.isChecked).map((el) => el.inputIndex))
    )
    setValidationInputUnconfirmedCount(unconfirmedInputs.length)
  }, [validationErrors])

  useEffect(() => {
    const pendingIndexes = Object.entries(l3CollapsedFlags).filter(([, value]) => value === 1)
    if (pendingIndexes.length > 0) {
      pendingIndexes.forEach(([idxStr]) => {
        const idx = Number(idxStr)
        setIsL3Collapsed(idx, false, fyear)
      })
      setL3CollapsedFlags((prev) => {
        const updated = { ...prev }
        pendingIndexes.forEach(([idxStr]) => {
          updated[Number(idxStr)] = 2
        })

        return updated
      })
    }
  }, [l3CollapsedFlags, fyear, setIsL3Collapsed])

  /** -------------------- Render ----------------------- */

  return (
    <div className={styles.root}>
      <Controller
        onValidationStatusChange={({ status }) => {
          status !== 'WIP' && setValidationStatus(status)
          updatePendingData(undefined, status)
        }}
      >
        {isShowPlanningSection && (
          <table className={cn(stylesTable.table, stylesCompensation.table, styles.table)}>
            <caption>
              <CategoryInfo
                dataSetInfo={props.dataSetInfo}
                partnerCountryCode={partnerInfo?.CountryCode}
                isShowTotal={props.isShowTotal}
                categoryName={categoryName}
              />
              <WidgetHeaderWithHelpButton section={HelpSection.FinancialAndSOB}>
                {categoryHeaderKey}
              </WidgetHeaderWithHelpButton>
              {isEditAllowed && (
                <tr>
                  <th colSpan={planningColSpan}>
                    <div className={styles.switchersContainer}>
                      {isShowNotApplicableWidget && (
                        <NotApplicableWidget
                          value={isCategoryNA}
                          className={styles.input}
                          canEdit={isNotApplicableAllowed && isEditAllowed}
                          onChange={async () => {
                            if (isNeedToShowSignNADialog) {
                              setIsShowSignDialogNA(true)
                            } else {
                              if (isCategoryNA) {
                                await onChangeNotApplicable()
                              } else {
                                setIsShowConfirmNotApplicableDialog(true)
                              }
                            }
                          }}
                        />
                      )}
                    </div>
                  </th>
                </tr>
              )}

              {isShowNotApplicableMessage && (
                <tr>
                  <th colSpan={planningColSpan}>
                    <div className={styles.input}>
                      <Translation span text="jbp-not-applicable-status-not-applicable" />
                    </div>
                  </th>
                </tr>
              )}

              {!isCategoryNA && (
                <tr>
                  <th colSpan={planningColSpan}>
                    <div className={styles.switchersContainer}>
                      {isShowCurrencyCtrl && <CurrenciesButtons />}
                      {isShowNetNdpCtrl && (
                        <>
                          <div className={styles.filterNextItemEmpty} />
                          <ActualsTypeButtons />
                        </>
                      )}
                      {isShowSalesTypeCtrl && (
                        <>
                          <div className={styles.filterNextItemEmpty} />
                          <SellTypeButtons actualsType={actualsType} />
                        </>
                      )}
                      {IS_ENABLE_ROUNDING && (
                        <>
                          <div className={styles.filterNextItemEmpty} />
                          <Tooltip
                            inline
                            tipContent={() => <Translation span text="jbp-planning-rounding-tip" />}
                            horizontalStartPosition={TPopupHorizontal.Center}
                            horizontalDirection={TPopupHorizontal.Right}
                          >
                            <RowButtons
                              generateTranslationKey={(value) => value}
                              value={props.roundingValue}
                              options={ROUNDING_VALUES}
                              onOptionClick={props.setRoundingValue}
                            />
                          </Tooltip>
                          {isRetailer && (
                            <>
                              <div className={styles.filterNextItemEmpty} />
                              <div className={styles.optionSwitcherContainer}>
                                <RowButtons
                                  value={isShowDetailedPlanning ? 'Hierarchical' : 'Flat'}
                                  options={DISPLAY_OPTIONS}
                                  generateTranslationKey={(val) => generateTranslationKey(val)}
                                  onOptionClick={() =>
                                    props.displaySettings.actions.setIsShowDetailedPlanning(
                                      !isShowDetailedPlanning
                                    )
                                  }
                                />
                              </div>
                            </>
                          )}
                          {isExistControlsAfterRounding && (
                            <div className={styles.filterNextItemEmpty}></div>
                          )}
                        </>
                      )}
                      {isShowActualsCtrl && !IS_ALWAYS_SHOW_ACTUALS && (
                        <div
                          className={cn(styles.filterItem, {
                            [styles.filterNextItem]: !isShowActualsCtrlFirst,
                          })}
                          style={{ color: actualsColor }}
                        >
                          <Checkbox
                            checked={props.showActuals}
                            label={<Translation text={'jbp-partner-actuals-show-actuals'} span />}
                            onChange={(val) => props.setShowActuals(!!val)}
                          />
                        </div>
                      )}
                      {/* {isShowQuotaCtrl && (
                        <div
                          className={cn(styles.filterItem, {
                            [styles.filterNextItem]: !isShowQuotaCtrlFirst,
                          })}
                          style={{ color: quotaColor }}
                        >
                          <Checkbox
                            checked={props.showQuota}
                            label={<Translation text={'jbp-partner-actuals-show-quota'} span />}
                            onChange={(val) => props.setShowQuota(!!val)}
                          />
                        </div>
                      )} */}
                      {isDistributor && isRegionalDistributor && (
                        <Checkbox
                          className={cn(styles.filterItem, {
                            [styles.filterNextItem]: !isShowDistributorCtrlFirst,
                          })}
                          checked={props.isRegionalPlanning}
                          label={
                            <Translation text={'jbp-distributor-show-regional-planning'} span />
                          }
                          onChange={(val) => props.setIsRegionalPlanning(!!val)}
                        />
                      )}

                      {isShowPrevTargetsCtrl && (
                        <div className={styles.filterItem}>
                          <Checkbox
                            checked={isShowPrevTargets}
                            onChange={(val) =>
                              props.displaySettings.actions.setIsShowPreviousPlans(!val)
                            }
                            label={
                              <Translation
                                span
                                text={`jbp-planning-show-prev-targets${
                                  props.showQuota ? '-quota' : ''
                                }`}
                                replaceParams={showPrevTargetsParams}
                              />
                            }
                          />
                        </div>
                      )}
                    </div>
                  </th>
                </tr>
              )}
            </caption>

            {!isCategoryNA && (
              <thead>
                {isUseContractuals && (
                  <SplitPlanningRow
                    splitType={splitType}
                    setSplitType={setSplitType}
                    isShowAllSplits={isShowAllSplits}
                    setIsShowAllSplits={setIsShowAllSplits}
                    isDistributorPlanner={props.isDistributorPlanner}
                    colSpan={planningColSpan}
                  />
                )}
                {!isCategoryNA && (
                  <>
                    {isShowMapRow && (
                      <MapRow
                        mapData={props.mapData}
                        fyear={fyear}
                        category={currentCat}
                        subCategory={OVERALL_CATEGORY}
                        tag="jbp-market-growth-guidance"
                        isYearlyPlanning={isYearlyPlanning}
                        isShowCalcActuals={isShowCalcActuals}
                        isShowFutureYears={isShowFutureYears}
                        hideIfEmpty
                      />
                    )}
                    <RetailCategoryHeader
                      cat={currentCat}
                      fyear={fyear}
                      valueType={currentValueType}
                    />
                  </>
                )}
              </thead>
            )}
            {!isCategoryNA && isShowCurrencyBlock && (
              <tbody>
                {props.formats.map((format, idx) => {
                  const cat = format.Category
                  const subCat = format.SubCategory

                  const isOverall = subCat === OVERALL_CATEGORY || !subCat
                  const isShowCollapseButton =
                    (isEditAllowed || props.composedReportMode) &&
                    isCollapseAllowed &&
                    !isOverallOnly &&
                    isOverall &&
                    !isAlwaysExpanded

                  const l3Cat = format.L3Category
                  const isL3Overall = l3Cat === OVERALL_CATEGORY
                  const isL3 = !!l3Cat

                  // Retail Collapse: isRetailer ||
                  const isCatForcedExpanded =
                    isRetailer ||
                    getIsExpandedByFlags({
                      settings: format.Settings,
                      flagsState: props.partnerFlagsState,
                    })

                  const isL3Collapsed =
                    getIsCollapsedL3Category(targetsItems, fyear, subCat) && !isCatForcedExpanded
                  const isShowL3CollapseButton =
                    (isEditAllowed || props.composedReportMode) &&
                    isL3 &&
                    isL3Overall &&
                    !isCatForcedExpanded
                  const isShowL3Border = isL3 && (!isL3Overall || (isL3Overall && !isL3Collapsed))
                  const isL3SubCat = isL3 && !isL3Overall
                  const l3Idx = getL3Index(format)

                  const uniqueCategory = isOverall ? cat : subCat
                  const uniqueKey = `jbp-planning-contractual-${uniqueCategory}`

                  const isEditRow = isEditAllowed && (!isOverall || isFixedCollapsed)

                  const isShowPartnersCompletenessForCategory =
                    IS_SHOW_PARTNERS_COMPLETENESS_FOR_SUB_CATEGORIES || isOverall

                  const isShowPartnersCompleteness =
                    !!props.composedReportMode &&
                    isShowPartnersCompletenessForCategory &&
                    (IS_SHOW_PARTNERS_COMPLETENESS_FOR_ALL_ROWS ||
                      (!isShowOnlyCompletedPlans &&
                        ((!isL3Overall && !isOverall) ||
                          (isL3Overall && isL3Collapsed) ||
                          (isOverall && isFixedCollapsed))))
                  const isAdjustPartnersCompleteness = isOverall || isL3Overall

                  const isHideRow =
                    // Retail
                    // isOverall ||
                    // Other
                    (isFixedCollapsed && !isOverall) || (isL3Collapsed && !isL3Overall)
                  // Other
                  // || (isEmptyRow &&
                  //   !isOverall &&
                  //   !isEditMode &&
                  //   !isAlwaysExpanded &&
                  //   !props.composedReportMode &&
                  //   !props.isQuarterlyBusinessReviewMode)

                  if (isHideRow) {
                    return (
                      <Fragment
                        key={`jbp-target-actuals-rows-${uniqueKey}-${idx}-hided`}
                      ></Fragment>
                    )
                  }

                  const isShowGlobalSoB =
                    !!partnerInfo?.IsGlobal && !!props.globalCategory?.IsSoBAvailable

                  // Retail SOB
                  // const isSobDetailsMandatoryCondition =
                  //   (!isRetailer && isSobDetailsMandatory) ||
                  //   (isRetailer && isSobDetailsMandatory && !isL3SubCat)
                  const isSobDetailsMandatoryCondition = isSobDetailsMandatory
                  const isShowSobDetailCondition =
                    isOverall || isSobDetailsMandatoryCondition || isOn(currentCat, 'sob-details')

                  const isShowSoB =
                    isShowGlobalSoB ||
                    (!partnerInfo?.IsGlobal &&
                      !isHideSoB &&
                      (isOverall || !props.composedReportMode) &&
                      (!props.composedReportMode || isShowComposedSoB) &&
                      isShowSobDetailCondition &&
                      ((!IS_ALWAYS_SHOW_SOB && isOn(currentCat, 'sob', IS_ALWAYS_SHOW_SOB)) ||
                        (IS_ALWAYS_SHOW_SOB && !!format.IsSoBAvailable)) &&
                      isNoSplitPlans)

                  const completenessItem = getCompletenessItem({
                    formats: props.formats,
                    settingsIndex: idx,
                    items: targetsItems,
                    fy: fyear,
                    isSoB: false,
                  })
                  const completenessAckTag = isShowOnlyCompletedPlans ? 'ack' : 'all'
                  const completenessTag = isShowSoB ? 'ful' : completenessAckTag

                  const onPartnersCompletenessClick = (
                    partnersCompleteness: IPartnersCompleteness
                  ) => {
                    const fullPartnersCompleteness: IPartnersCompleteness = {
                      ...partnersCompleteness,

                      fYear: fyear,
                      fQuarter: PLANNING_BY_FY_FQ,
                      category: cat,
                      subCategory: subCat,
                      l3Category: l3Cat,
                      isActuals: 0,
                      isTargets: 1,
                      isSob: 0,

                      isAcknowledged: isShowOnlyCompletedPlans ? 1 : 0,
                      isCompleted: isShowSoB ? 1 : 0,
                    }

                    setPartnersCompleteness(fullPartnersCompleteness)
                  }

                  // Old clause for Global: !!partnerInfo?.IsGlobal && !isOverall
                  const isHideCategoryToolTip = false

                  const isSubCatCell = !isOverall && isL3Overall

                  if (isOverall) {
                    return (
                      <Fragment key={`jbp-target-actuals-rows-${uniqueKey}-${idx}-subCat`}>
                        <tr
                          key={`jbp-target-actuals-${uniqueKey}-${idx}`}
                          className={cn({ [styles.contractualTotalRow]: isUseContractuals })}
                        >
                          <td
                            className={cn(
                              styles.subCatHeaderCell,
                              { [styles.catTitle]: !isEditRow },
                              { [styles.catTitleEdit]: isEditRow },
                              { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                              { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                              { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                              { [styles.catL3p]: isL3 },
                              { [styles.catL2]: !isOverall && !isL3 },
                              { [styles.catL3]: isL3SubCat && !isEditAllowed },
                              { [styles.catL3Edit]: isL3SubCat && isEditAllowed },
                              { [styles.subCatCell]: isSubCatCell },
                              { [styles.overallCell]: isOverall }
                            )}
                            colSpan={2}
                          >
                            <Translation text={subCat} span actionsInside />
                          </td>
                          {renderOverall(idx, isOverall, isL3Overall)}
                        </tr>
                      </Fragment>
                    )
                  }

                  if (isL3Overall) {
                    return (
                      <Fragment key={`jbp-target-actuals-rows-${uniqueKey}-${idx}-subCat`}>
                        <tr
                          key={`jbp-target-actuals-${uniqueKey}-${idx}`}
                          className={cn({ [styles.contractualTotalRow]: isUseContractuals })}
                        >
                          <td
                            className={cn(
                              styles.subCatHeaderCell,
                              { [styles.catTitle]: !isEditRow },
                              { [styles.catTitleEdit]: isEditRow },
                              { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                              { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                              { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                              { [styles.catL3p]: isL3 },
                              { [styles.catL2]: !isOverall && !isL3 },
                              { [styles.catL3]: isL3SubCat && !isEditAllowed },
                              { [styles.catL3Edit]: isL3SubCat && isEditAllowed },
                              { [styles.subCatCell]: isSubCatCell },
                              { [styles.overallCell]: isOverall }
                            )}
                            colSpan={2}
                          >
                            <Translation text={subCat} span actionsInside />
                          </td>
                          {renderOverall(idx, isOverall, isL3Overall)}
                        </tr>
                      </Fragment>
                    )
                  }

                  return (
                    <Fragment key={`jbp-target-actuals-rows-${uniqueKey}-${idx}`}>
                      {isShowMapRow && !isOverall && (
                        <SubCategoryMapRow
                          mapData={props.mapData}
                          fyear={fyear}
                          category={cat}
                          subCategory={subCat}
                          l3Category={l3Cat}
                          tag="jbp-market-growth-guidance-short"
                          isShowCalcActuals={isShowCalcActuals}
                          isShowFutureYears={isShowFutureYears}
                          hideIfEmpty
                        />
                      )}
                      <tr
                        key={`jbp-target-actuals-${uniqueKey}-${idx}`}
                        className={cn({ [styles.contractualTotalRow]: isUseContractuals })}
                      >
                        <td
                          className={cn(
                            styles.totalCell,
                            { [styles.catTitle]: !isEditRow },
                            { [styles.catTitleEdit]: isEditRow },
                            { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                            { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                            { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                            { [styles.catCode]: true }
                          )}
                        >
                          {format.PLs}
                        </td>
                        <td
                          className={cn(
                            styles.totalCell,
                            { [styles.catTitle]: !isEditRow },
                            { [styles.catTitleEdit]: isEditRow },
                            { [styles.catL30]: isShowL3Border && l3Idx === 0 && false },
                            { [styles.catL31]: isShowL3Border && l3Idx === 1 && false },
                            { [styles.catL32]: isShowL3Border && l3Idx === 2 && false },
                            { [styles.catL3p]: isL3 },
                            { [styles.catL2]: !isOverall && !isL3 },
                            { [styles.catL3]: isL3SubCat && !isEditAllowed },
                            { [styles.catL3Edit]: isL3SubCat && isEditAllowed }
                          )}
                        >
                          {isL3 && !isL3Overall && IS_USE_LEVEL_ICON && (
                            <span className={styles.l3icon}>
                              <i
                                className={'kbase kbase-arrow-right'}
                                style={{ color: '#2c3038', fontWeight: 'bold' }}
                              />
                            </span>
                          )}
                          {!isShowCollapseButton && !isShowL3CollapseButton && (
                            <div className={styles.categoryTitle}>
                              <div>
                                <RetailCategoryTitle
                                  category={cat}
                                  subCategory={subCat}
                                  l3Category={l3Cat}
                                  tip={format.PopupComment}
                                  tipPrefix={globalCategoryTipPrefix}
                                  isHideTooltip={isHideCategoryToolTip}
                                />
                              </div>
                            </div>
                          )}
                          {isShowPartnersCompleteness && (
                            <div
                              className={cn(styles.partnersCompleteness, {
                                [styles.partnersCompletenessAdjust]: isAdjustPartnersCompleteness,
                              })}
                            >
                              <br />
                              <PartnersCompletenessField
                                translationTag={completenessTag}
                                partnersCompleteness={completenessItem}
                                onClick={onPartnersCompletenessClick}
                              />
                            </div>
                          )}
                        </td>

                        {renderL3(idx, isOverall)}
                      </tr>
                    </Fragment>
                  )
                })}
              </tbody>
            )}

            {isShowComposedReportCollapsedWarning && (
              <tfoot>
                <tr>
                  <th colSpan={planningColSpan}>
                    {props.showActuals && (
                      <div className={styles.infoContainer}>
                        <i
                          className={cn('kbase kbase-info-alt', styles.infoIcon)}
                          aria-hidden="true"
                        />
                        <span className={styles.composedReportLegend}>
                          <Translation text="jbp-planning-composed-report-warning" actionsInside />
                        </span>
                      </div>
                    )}
                  </th>
                </tr>
              </tfoot>
            )}
          </table>
        )}

        {isShowApplyBeforeUnits && renderApplySection()}

        {isShowApplySection && renderApplySection()}

        {/** -------------------- Render dialogs ----------------------- */}

        <ConfirmNotApplicableDialog
          isShowDialog={isShowConfirmNotApplicableDialog}
          category={t(currentCat)}
          onConfirm={confirmNotApplicable}
          onClose={cancelNotApplicable}
        />

        <ModalDialog
          show={isShowSignDialogNA}
          size={'sm'}
          content={CommitmentChangeDialog}
          header={() => (
            <WidgetHeader className={styles.modalDialogHeader}>jbp-confirm-changes</WidgetHeader>
          )}
          contentProps={{
            partnerId: partnerId,
            fyear: fyear,
            programType: buttonCurrType,
            metrics: props.metrics,
            onApply: async () => {
              setIsShowSignDialogNA(false)

              await onChangeNotApplicable()
            },
            onCancel: () => setIsShowSignDialogNA(false),
          }}
          onClose={() => setIsShowSignDialogNA(false)}
        />

        <ModalDialog
          show={isShowRateDialog}
          size={'sm'}
          content={TypeChangeDialog}
          contentProps={{
            content: <Translation span text="jbp-planning-rounding-warning" />,
            onDiscard: () => {
              setIsShowRateDialog(false)
              discardChanges()
            },
            onApply: async () => {
              setIsShowRateDialog(false)

              const isSignatureWillBeDropped =
                isNeedToShowSignDialog && !isOverallValueNotChanged(partnerInfo)

              if (isSignatureWillBeDropped) {
                setIsShowSignDialog(true)
              } else if (isSwitchersChanged) {
                setIsShowConfirmSwitchersChangeDialog(true)
              } else {
                await applyChanges(targetsItems)
              }
            },
            onCancel: () => setIsShowRateDialog(false),
          }}
          onClose={() => setIsShowRateDialog(false)}
        />

        <ModalDialog
          show={isShowSignDialog}
          size={'sm'}
          content={CommitmentChangeDialog}
          header={() => (
            <WidgetHeader className={styles.modalDialogHeader}>jbp-confirm-changes</WidgetHeader>
          )}
          contentProps={{
            partnerId: partnerId,
            fyear: fyear,
            programType: buttonCurrType,
            metrics: props.metrics,
            onDiscard: () => {
              setIsShowSignDialog(false)
              discardChanges()
            },
            onApply: async () => {
              setIsShowSignDialog(false)

              if (isSwitchersChanged) {
                setIsShowConfirmSwitchersChangeDialog(true)
              } else {
                await applyChanges(targetsItems)
              }
            },
            onCancel: () => setIsShowSignDialog(false),
          }}
          onClose={() => setIsShowSignDialog(false)}
        />

        <ConfirmSwitchersChangeDialog
          isShowDialog={isShowConfirmSwitchersChangeDialog}
          currCurrency={props.originalCurrency}
          currActualsValueType={props.originalActualsValueType}
          currency={currency}
          actualsValueType={actualsType}
          onConfirm={async () => {
            setIsShowConfirmSwitchersChangeDialog(false)
            await applyChanges(targetsItems)
          }}
          onClose={() => {
            setIsShowConfirmSwitchersChangeDialog(false)
          }}
        />

        <EditCommentDialog
          isShowDialog={!!editCommentEditor}
          currentEditComment={editCommentEditor?.comment || ''}
          onApply={async (value: any) => {
            if (editCommentEditor) {
              setCustomField(
                editCommentEditor.index,
                value,
                editCommentEditor.year,
                editCommentEditor.q,
                'Comment',
                'targets'
              )
            }

            setCommentEditor(undefined)
          }}
          onCancel={() => {
            setCommentEditor(undefined)
          }}
        />

        <ConfirmPolyPlanningLevelDialog
          isShowDialog={!!polyPlanningLevel}
          newPolyPlanningLevel={polyPlanningLevel}
          onConfirm={async () => {
            setPolyPlanningLevel('')

            const finSobProps = getFinSobProps()
            const finSobValidationResult = isFinSobPlanQuarterlyChecksEnabled
              ? checkFinSobValues(finSobProps)
              : []
            const isSignatureWillBeDropped =
              isNeedToShowSignDialog && !isOverallValueNotChanged(partnerInfo)

            if (finSobValidationResult.length > 0) {
              // Find first unconfirmed Input index
              const unconfirmedInputIndexes = Array.from(
                new Set(finSobValidationResult.map((el) => el.inputIndex))
              ).sort((a, b) => a - b)
              const newInputIndex = unconfirmedInputIndexes[0]

              setValidationErrors(finSobValidationResult)
              setValidationInputIndex(newInputIndex)
              switchSplitType(newInputIndex, finSobValidationResult)

              props.setIsShowValidationPopup(true)
            } else if (!checkFinSobRate(finSobProps)) {
              setIsShowRateDialog(true)
            } else if (isSignatureWillBeDropped) {
              setIsShowSignDialog(true)
            } else if (isSwitchersChanged) {
              setIsShowConfirmSwitchersChangeDialog(true)
            } else {
              await applyChanges(targetsItems)
            }
          }}
          onClose={() => {
            setPolyPlanningLevel('')
          }}
        />

        <PartnersCompletenessDialog
          isShowDialog={!!partnersCompleteness}
          partnersCompleteness={partnersCompleteness}
          onConfirm={async () => {
            setPartnersCompleteness(undefined)
          }}
          onClose={() => {
            setPartnersCompleteness(undefined)
          }}
        />
      </Controller>
    </div>
  )
}
